"use strict";

let welcomeIntervalId = null;

const isMobileScreen = function isMobileScreen() {
    return document.body.clientWidth <= 767;
};
const isDesktopScreen = function isDesktopScreen() {
    return document.body.clientWidth >= 1024;
};
const isTableScreen = function isTableScreen() {
    return document.body.clientWidth > 767 && document.body.clientWidth < 1025;
};

const isTableAndDesktopScreen = function isDesktopScreen() {
    return document.body.clientWidth >= 768;
};

// VNYL-1379 / VNYL-1484: the open search bar is the header's second row (home /
// shop / creators / search results, and the PDP when its setting says so).
// Everywhere else the icon expands it, and tap-away should close. The pages are
// decided once in snippets/header-second-row.liquid and read here from
// .header-group[data-second-row].
const isPinnedSearchSecondRow = function isPinnedSearchSecondRow() {
    const headerGroup = document.querySelector(".header-group");
    const secondRow = headerGroup && headerGroup.getAttribute("data-second-row");
    return secondRow === "search" || secondRow === "search-and-chips";
};

// Whether the mobile search bar renders open at page top. Same pages as
// sections/header.liquid `is_valid_url`.
const isSearchOpenDefaultUrl = function isSearchOpenDefaultUrl() {
    return isPinnedSearchSecondRow();
};

// VNYL-1434: session key holding how deep into vinyl.com the current history
// entry sits. Depth 1 = the page the visitor entered the site on, so pressing
// Back from it leaves vinyl.com. Written by app.trackInSiteDepth().
const VINYL_INSITE_DEPTH_KEY = 'vinyl_welcome_discount_insite_depth';

// VNYL-1434: keep the exit trigger's history bookkeeping alive when other
// scripts rewrite history state. Shopify's option_selection.js (variant change)
// and vinyl-charts.js both call replaceState({}, ...), which would otherwise
// wipe the vinylDepth / vinylExitSentinel tags off the current entry.
(function preserveVinylHistoryState() {
    if (!window.history || !window.history.replaceState || window.history.__vinylPatched) return;
    const nativeReplaceState = window.history.replaceState;
    const PRESERVED_KEYS = ['vinylDepth', 'vinylExitSentinel'];
    window.history.replaceState = function (state, title, url) {
        const prev = window.history.state || {};
        const next = Object.assign({}, state || {});
        PRESERVED_KEYS.forEach(function (key) {
            // A caller that sets the key itself wins; otherwise carry it over.
            if (key in prev && !(key in next)) next[key] = prev[key];
        });
        return nativeReplaceState.call(window.history, next, title, url);
    };
    window.history.__vinylPatched = true;
})();

var $ = jQuery.noConflict();

const ShopifyIdType =  {
    ProductImage: "ProductImage",
    Product: "Product",
    MediaImage: "MediaImage",
    Customer: "Customer",
    Collection: "Collection",
    Order: "Order",
    Fulfillment: "Fulfillment",
}

const app = {
    showMoreCounter: 0,
    init: function init() {
        this.showMoreCounter = 0;
        this.autoSelectCountry();
        this.hanldeAccordion();
        this.sticky();
        this.checkOS();
        this.swiper();
        this.marqueeText2();
        this.checkContainerOffsetLeft();
        this.checkContainerOffsetRight();
        this.headerActions();
        this.showReadMore();
        this.searchForm();
        this.mobileFilter();
        this.addToCart();
        this.handleDiscountUrl();
        this.handleUrlFromTheBrag();
        this.heroSlider();
        this.collectionsHeroSlider();
        this.mobileOffcanvas();
        this.initializeTooltips();
        this.initDateTimePicker();
        this.getCustomerAccessTokenByCredentials();
        this.updateAirshipTimezone();
        this.listenMobileCartClick();
        this.preserveCartScrollOnClose();
        this.trackInSiteDepth();
        this.welcomeDiscountHandler();
    },
    clickShopPayBtn: async function(productList, handle) {
        const localProduct = window.currentProduct;
        if (!productList || productList.length === 0 || !localProduct) return;
        try {
            const url = `${PROXY_BASE_URL}/products/get-product-by-ids?ids=${productList.map(item => this.getShopifyNumberId(item))}`;
            let response = fetch(url, { method: 'GET'})
            .then(async (response)=>{
                if(response.ok && response.status === 200){
                    const data = await response.json();
                    const products = data?.products || [];
                    if (products.length === 0) return;
                    let currency_local = window.Shopify.currency.active || "USD";
                    const cart_number_items = 1;
                    const cart_product_sku = [localProduct.variants[0]?.sku];
                    const cart_product_name = [localProduct.title];
                    const cart_value_local = (localProduct.price / 100) * 1;
                    const cart_value_usd = Number(products[0]?.variants[0]?.price || 0);
    
                    // tracking
                    utils.mixpanelRetryWrapper.track('Checkout Started',{
                        cart_number_items,
                        cart_product_sku,
                        cart_product_name,
                        cart_value_usd,
                        cart_value_local,
                        currency_local,
                        referred_from: "product_page_shop_now"
                    });
                }
                return null;
            })
            .catch((error)=>{
                throw error;
            });
            app.fetchProductListByAjax(handle)
            .then(products => {
                //get compare_at_price from products and add to productsInCart 
                const product = products[0];
                // sent event to airship: products_in_cart: product_name, price_local, compare_at_price_local, product_url, product_image_url, currency_local, product_quantity
                const productsInCartBody = {
                    product_name: product.title,
                    price_local: product.price / 100,
                    compare_at_price_local: product.compare_at_price / 100,
                    product_url: window.location.origin + `/products/${product.handle}`,
                    product_image_url: product.image,
                    currency_local: Shopify.currency.active,
                    product_quantity: 1,
                    artist: curr.title.split(" - ")[0],
                    handle: curr.handle,
                    currency_symbol: currency === "GBP" ? "£" : "$",
                }
                //caculate cartSubtotalLocal by sum all original price of products in cart
                const cartSubtotalLocal = product.variants[0]?.price / 100;
                //caculate cartTotalLocal by sum all final price of products in cart
                const cartTotalLocal = product.variants[0]?.price / 100;
                //caculate cartDiscountLocal by sum all total_discount of products in cart
                const cartDiscountLocal = 0;
                const airshipCheckoutStartedEventBody = {
                    productsInCart: productsInCartBody,
                    checkoutUrl: `${window.location.origin}/checkouts/cn/${utils.getCookie('cart').split('?')[0]}`,
                    cartSubtotalLocal,
                    cartTotalLocal,
                    cartDiscountLocal,
                }
                airship.triggerAddedToCartEventInAirship(airshipCheckoutStartedEventBody);
            });

        } catch (err) {
            console.log(err)
        }

        utils.mixpanelRetryWrapper.track('Loaded a Page',{
            name: 'checkout'
        })
    },
    sticky: function () {
        const sticky = jQuery36("#siteHeader"),
          scroll = jQuery36(window).scrollTop();
        if (scroll >= 10) sticky.addClass("sticky-top");
        else sticky.removeClass("sticky-top");
    },
    checkOS: function () {
        let OSName = "Unknown OS";
        if (navigator.appVersion.indexOf("Win") != -1) {
            OSName = "Windows";
            console.log("Your OS: " + OSName);
            jQuery36("body").addClass("windows-ios");
        }
        if (navigator.appVersion.indexOf("Mac") != -1) {
            OSName = "MacOS";
            console.log("Your OS: " + OSName);
            jQuery36("body").addClass("mac-ios");
        }
    },
    marqueeText2: function () {
        try {
            // var splide = new Splide( '#splide1', {
            //     type   : 'loop',
            //     drag   : 'free',
            //     focus  : 'center',
            //     gap: 24,
            //     autoWidth: true,
            //     // perPage: 6,
            //     arrows: false,
            //     pagination: false,
            //     pauseOnCycle: false,
            //     pauseOnHover: false,
            //     pauseOnFocus: false,
            //     autoScroll: {
            //         speed: 0.4,
            //     },
            // } );

            // splide.mount(window.splide.Extensions);
        } catch (e) {
            return 1
        }
    },
    heroSlider: function () {
        try {
            // var splide = new Splide('#splide2', {
            //     type: 'loop',
            //     drag   : 'free',
            //     direction: 'ttb',
            //     arrows: false,
            //     pagination: false,
            //     heightRatio: 1.5,
            //     lazyLoad: 'nearby',
            //     pauseOnCycle: false,
            //     pauseOnHover: false,
            //     pauseOnFocus: false,
            //     autoScroll: {
            //         speed: 0.4,
            //     },
            //     grid: {
            //         rows: 6,
            //         cols: 4,
            //     },
            //     breakpoints: {
            //         1399: {
            //             heightRatio: 8 / 3,
            //             grid: {
            //                 rows: 8,
            //                 cols: 3,
            //             },
            //         },
            //         1199: {
            //             heightRatio: 2,
            //             grid: {
            //                 rows: 4,
            //                 cols: 2,
            //             },
            //         },
            //         991: {
            //             drag   : false,
            //             heightRatio: 0.75,
            //             grid: {
            //                 rows: 3,
            //                 cols: 4,
            //             },
            //         }

            //     },
            // });

            // splide.mount(window.splide.Extensions);
        } catch (e) {
            return 1
        }
    },
    collectionsHeroSlider: function () {
        // VNYL-1481: splide.min.js is only loaded on the templates that render a
        // Splide carousel, and app.init() calls this on every page. Bail out
        // quietly instead of throwing into the catch below on every page load.
        if (typeof Splide === 'undefined') return;
        try {
            var splide = new Splide('#splide3', {
                type: 'loop',
                drag: 'free',
                direction: 'ttb',
                arrows: false,
                pagination: false,
                heightRatio: 3,
                lazyLoad: 'nearby',
                pauseOnCycle: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoScroll: {
                    speed: 0.4,
                },
                grid: {
                    rows: 3,
                    cols: 1,
                },
                breakpoints: {
                    991: {
                        drag: false,
                    }

                },
            });

            splide.mount(window.splide.Extensions);
        } catch (e) {
            return 1
        }
    },
    cartSwipe: function () {
        try {
            // let productSwiperWidth = document.getElementsByClassName("product-swiper")[0]?.offsetWidth;
            // let slidesPerView = (spaceBetween)=>(productSwiperWidth/(250+spaceBetween)).toFixed(2);
            if(app.cartSwiperObj) {
                app.cartSwiperObj.destroy();
            }
            if (jQuery36(".cart-recommendation .product-swiper:not(.small)").length>0){
                app.cartSwiperObj = new Swiper(".cart-recommendation .product-swiper:not(.small)", {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    loop: true,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: true,
                    },
                    navigation: {
                        nextEl: ".swiper-custom-button-next",
                        prevEl: ".swiper-custom-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    },
                });
            }
        } catch (error) {
            console.error('handled cartSwipe error:');
            console.error(error);
        }
    },
    swiper: function () {
        try {
            let headerContainer = jQuery36("#siteHeader > .header-inner > .container");
            let productSwiperWidth = document.getElementsByClassName("product-swiper")[0]?.offsetWidth;
            let slidesPerView = (spaceBetween)=>(productSwiperWidth/(250+spaceBetween)).toFixed(2);
            if(app.swiperObj){
                app.swiperObj.destroy();
            }
            if(app.swiperSmallObj){
                app.swiperSmallObj.destroy();
            }
            if(app.articleSwiperObj) {
                app.articleSwiperObj.destroy();
            }
            if(app.cartSwiperObj) {
                app.cartSwiperObj.destroy();
            }
            if (jQuery36(".cart-recommendation .product-swiper:not(.small)").length>0){
                app.cartSwiperObj = new Swiper(".cart-recommendation .product-swiper:not(.small)", {
                    slidesPerView: slidesPerView(10),
                    spaceBetween: 10,
                    loop: true,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: true,
                    },
                    navigation: {
                        nextEl: ".swiper-custom-button-next",
                        prevEl: ".swiper-custom-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: slidesPerView(20),
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: slidesPerView(30),
                            spaceBetween: 30,
                        }
                    },
                });
            }

            if(jQuery36(".product-swiper:not(.small)").filter(function() {
                    return jQuery36(this).closest('.cart-recommendation').length === 0;
                }).length>0
            ){
                app.swiperObj = new Swiper(".product-swiper:not(.small)", {
                    slidesPerView: slidesPerView(10),
                    spaceBetween: 10,
                    loop: true,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: true,
                    },
                    navigation: {
                        nextEl: ".swiper-custom-button-next",
                        prevEl: ".swiper-custom-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: slidesPerView(20),
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: slidesPerView(30),
                            spaceBetween: 30,
                        }
                    },
                });
            }
            if(jQuery36(".product-swiper.small").filter(function() {
                    return jQuery36(this).closest('.cart-recommendation').length === 0;
                }).length>0){
                app.swiperSmallObj = new Swiper(".product-swiper.small", {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                    loop: true,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: true,
                    },
                    navigation: {
                        nextEl: ".swiper-custom-button-next",
                        prevEl: ".swiper-custom-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2.75,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3.75,
                            spaceBetween: 30,
                        },
                    },
                });  
            }
            if(jQuery36(".article-swiper").length>0){
                app.articleSwiperObj = new Swiper(".article-swiper",{
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    loop: false,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: true,
                    },
                    navigation: {
                        nextEl: ".swiper-custom-button-next",
                        prevEl: ".swiper-custom-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2.75,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3.75,
                            spaceBetween: 30,
                        },
                    },
                })
            }
        } catch (error) {
            console.error('handled error:');
            console.error(error);
        }
    },
    checkContainerOffsetLeft: function () {
        var container = jQuery36(".calc-offset-left");
        var containerInner = jQuery36(".calc-offset-left .creator-content-inner, .calc-offset-left .swiper-header");
        var headerContainer = jQuery36("#siteHeader > .header-inner > .container");
        var left = headerContainer.offset().left + 15;

        if (isTableAndDesktopScreen()) {
            container.css("padding-left", left);
            containerInner.css("padding-right", left);
        } else {
            container.removeAttr("style");
            containerInner.removeAttr("style");
        }
    },
    mobileOffcanvas: function () {
        var menuToggle = jQuery36(".toggle-menu");
        var mobileMenuWrap = jQuery36("#mobileMenuWrap");
        var closeMenu = jQuery36(".close-menu");
        var menu = new MmenuLight(document.querySelector("#mobileMenuWrap"), "all");
        var navigator = menu.navigation({
            // selectedClass: 'Selected',
            slidingSubmenus: true,
            theme: 'dark',
            title: 'Menu'
        });
        var drawer = menu.offcanvas({
            position: 'left'
        });
        // VNYL-1552: the in-menu search is the header's SearchSuggestion component,
        // mounted from search-suggestion.bundle.js — it owns its own submit and tracking.
        // const menuItem = jQuery36(".menu-item-content");
        // const footerItem = jQuery36(".footer-item");
        if(!isDesktopScreen()) {
            menuToggle.click("on", function (event) {
                // menuWrap.slideDown("fast");
                // bodyElm.addClass("overflow-hidden");
                event.preventDefault();

                mobileMenuWrap.removeClass('mobile-menu-fade-out');
                mobileMenuWrap.addClass('mobile-menu-fade-in');
                mobileMenuWrap.css('display','block');
                // VNYL-1552: open on the menu links, not a search panel left open
                // last time (SearchSuggestion closes its panel on this event).
                document.dispatchEvent(
                    new CustomEvent("search-suggestion:action", { detail: { action: "close" } })
                );
                drawer.open();
                // VNYL-1555: once per open. Closing the menu or opening a submenu
                // doesn't come through here.
                try {
                    if (typeof utils !== "undefined" && utils.mixpanelRetryWrapper) {
                        utils.mixpanelRetryWrapper.track("Mobile Menu Opened", {
                            page: app.getPageNameFromUrl(),
                        });
                    }
                } catch (e) {
                    // ignore tracking failures
                }
            });
            closeMenu.click("on", function (event) {
                // menuWrap.slideUp("fast");
                // bodyElm.removeClass("overflow-hidden");
                event.preventDefault();
                mobileMenuWrap.removeClass('mobile-menu-fade-in');
                mobileMenuWrap.addClass('mobile-menu-fade-out');
                drawer.close();
            });
        }
    },
    headerActions: function () {
        var searchToggle = jQuery36(".search-toggle");
        var searchFormWrap = jQuery36(window.innerWidth < 992 ? "#headerFormMobileSearch" : "#headerFormSearch");
        var bodyElm = jQuery36("body");
        
        if (isDesktopScreen()) {
          if (searchFormWrap.is(":hidden")) {
            searchFormWrap.removeAttr("style");
          }
        } else {
          // VNYL-1484: keep .header-group[data-search-open] in sync with the bar
          // visibility so adaptive-header.css can promote the search bar into
          // the "second row" slot while it's open on icon-only surfaces.
          var headerGroup = document.querySelector(".header-group");
          var setSearchOpenAttr = function (isOpen) {
            if (!headerGroup) return;
            if (isOpen) {
              headerGroup.setAttribute("data-search-open", "true");
            } else {
              headerGroup.removeAttribute("data-search-open");
            }
          };
          searchToggle.click(function (e) {
            // Compact CSS hides the bar with display:none !important, so
            // :visible is always false until data-search-open is set. Drive
            // open/close from that attribute, not from computed visibility.
            var isOpen = !(headerGroup && headerGroup.getAttribute("data-search-open") === "true");
            if (isOpen) {
              searchFormWrap.show();
              searchFormWrap.addClass("open-search-bar");
              setSearchOpenAttr(true);
              searchFormWrap.find(".input-search").focus();
            } else {
              searchFormWrap.hide();
              searchFormWrap.removeClass("open-search-bar");
              setSearchOpenAttr(false);
            }
            e.stopPropagation();
            e.preventDefault();
          });
          jQuery36(window).click(function (e) {
            e.stopPropagation();
            var target = e.target;
            if (
              !jQuery36(target).closest(window.innerWidth < 992 ? "#headerFormMobileSearch" : "#headerFormSearch").length &&
              !jQuery36(target).closest(".search-toggle").length &&
              !jQuery36(target).closest(".search-dropdown").length &&
              !isPinnedSearchSecondRow()
            ) {
               searchFormWrap.hide();
               searchFormWrap.removeClass("open-search-bar");
               setSearchOpenAttr(false);
            }
          });
        }
    },
    mobileHeaderActions: function () {
        var siteMain = jQuery36("#siteMain");
        var searchToggle = jQuery36(".search-toggle");
        var searchFormWrap = jQuery36(window.innerWidth < 992 ? "#headerFormMobileSearch" : "#headerFormSearch");
        const isValidMobileActionUrl = isSearchOpenDefaultUrl();

        if (!isDesktopScreen() && isValidMobileActionUrl) {
            searchToggle.hide();
            searchFormWrap.show();
            searchFormWrap.addClass('open-search-bar');
            siteMain.css('padding-top', '52px');
        }
        if (!isDesktopScreen() && !isValidMobileActionUrl) {
            searchToggle.show();
            searchFormWrap.hide();
            searchFormWrap.removeClass('open-search-bar');
            siteMain.css('padding-top', '0px');
        }
    },
    scrollDownHeaderAction: function () {
        var siteMain = jQuery36("#siteMain");
        var searchFormWrap = jQuery36(window.innerWidth < 992 ? "#headerFormMobileSearch" : "#headerFormSearch");
        const isValidMobileActionUrl = isSearchOpenDefaultUrl();
        if (!isDesktopScreen() && isValidMobileActionUrl) {
            document.dispatchEvent(new CustomEvent('search-suggestion:action', { detail: { action: 'close' } }));
            searchFormWrap.css('top', '0');
            // siteMain.css('padding-top', '0px');
        }
    },
    scrollUpHeaderAction: function () {
        var siteMain = jQuery36("#siteMain");
        var searchFormWrap = jQuery36(window.innerWidth < 992 ? "#headerFormMobileSearch" : "#headerFormSearch");
        const isValidMobileActionUrl = isSearchOpenDefaultUrl();
        if (!isDesktopScreen() && isValidMobileActionUrl) {
            document.dispatchEvent(new CustomEvent('search-suggestion:action', { detail: { action: 'open' } }));
            searchFormWrap.css('top', '100%');
            // siteMain.css('padding-top', '');
        }
    },
    searchForm: function () {
        var inputSearch = jQuery36(`${window.innerWidth < 992 ? "#headerFormMobileSearch .input-search" : "#headerFormSearch .input-search"}`);

        inputSearch.on("input", function () {
            if (jQuery36(this).val().length > 0) {
                jQuery36(this).next(".button-search").show();
            } else {
                jQuery36(this).next(".button-search").hide();
            }
        });
    },
    splitOn: (bound, cutElement)=>{
		var grandparent;
        // cutElement must be a descendant of bound
        for (var parent = cutElement.parentNode; bound != parent; parent = grandparent) {
            var right = parent.cloneNode(false);
            while (cutElement.nextSibling)
                right.appendChild(cutElement.nextSibling);
            grandparent = parent.parentNode;
            grandparent.insertBefore(right, parent.nextSibling);
            grandparent.insertBefore(cutElement, right);
        }
    },
    showReadMore: function () {
        try {
            var moretext = "Read more";
            var lesstext = "Show less";
            // let fullContent = "";
            // let firstPartContent = "";
            // let app = this;
            const morelink = 
                '<a href="#" class="morelink">' +
                moretext +
                "</a>";
            jQuery36(".show-read-more:not(.skeleton .show-read-more)").each(function () {
                if(jQuery36(this).find('.morelink').length==0){
                    let innerShowReadMore = jQuery36(this).find('.inner-show-read-more');
                    if(innerShowReadMore){
                        let heightBeforeCrop = innerShowReadMore.height();
                        if(heightBeforeCrop==0){
                            return;
                        }
                        if (app.showMoreCounter === 0 ) {
                            app.showMoreCounter = app.showMoreCounter + 1;
                            innerShowReadMore.addClass(["less", "read-more-inline"]);
                            let heightAfterCrop = innerShowReadMore.height();
                            if(heightBeforeCrop!=heightAfterCrop){
                                jQuery36(this).append(morelink);
                            }
                        }
                    }
                }
                // fullContent = jQuery36(this).html();
                // let stripHtmlContent = fullContent.replace(/(<([^>]+)>)/gi, "");
                // if (stripHtmlContent.length > showChar){
                //     let breakSignal = `<!--break-->`;
                //     jQuery36(this).html(fullContent.slice(0, showChar)+breakSignal+fullContent.slice(showChar));
                //     let contentWithBreakSignal = jQuery36(this)[0];
                //     let cutElement = document.createNodeIterator(contentWithBreakSignal, NodeFilter.SHOW_COMMENT, null, true).nextNode();
                //     app.splitOn(contentWithBreakSignal, cutElement);
                //     let c = contentWithBreakSignal.firstElementChild.outerHTML;
                //     let ellipsesElement = '<span class="moreellipses">' +
                //     ellipsestext +
                //     '&nbsp;</span>'
                //     firstPartContent =  jQuery36(c).append(ellipsesElement).html();
                //     let html = '<div id="desc-content">'+firstPartContent+'</div>'+ morelink;
                //     jQuery36(this).html(html);
                // }

            }); 
            if (app.showMoreCounter === 1) {
                app.showMoreCounter = app.showMoreCounter + 1;
                jQuery36(".morelink").click(function () {
                    const content = jQuery36(this).prev();
                    if (content.hasClass("less")) {
                        content.removeClass(["less", "read-more-inline"]);
                        jQuery36(this).html(lesstext);
                        utils.mixpanelRetryWrapper.track('Read More Expanded')
                        // jQuery36("#desc-content").each(function () {
                        //     jQuery36(this).html(firstPartContent);
                        // })
                    } else {
                        content.addClass(["less", "read-more-inline"]);
                        jQuery36(this).html(moretext);
                        // jQuery36("#desc-content").each(function () {
                        //     jQuery36(this).html(fullContent);
                        // })
                    }
                    return false;
                });
                jQuery36('.show-read-more .cover-container').remove();
            }

        } catch (error) {
            jQuery36('.show-read-more .cover-container').remove();
            console.error("showReadMore error:");
            console.error(error);
        }
    },
    mobileFilter: function () {
        var toggle = jQuery36(".toggle-filter");
        var filterBar = jQuery36("#filterPopup");
        var closeButton = jQuery36(".close-filter");
        var bodyElm = jQuery36("body");

        if (isDesktopScreen()) {
            filterBar.removeAttr("style");
            bodyElm.removeClass("overflow-hidden");
        } else {
            toggle.on("click", function () {
                filterBar.slideDown();
                bodyElm.addClass("overflow-hidden");
            });

            jQuery36(".filter-product-list .filter-apply-btn").click(() => bodyElm.removeClass("overflow-hidden"));
            
            closeButton.on("click", function () {
                filterBar.slideUp("fast");
                bodyElm.removeClass("overflow-hidden");
            });
        }
    },
    handleBuyClick: function(event){
        let buttonBuy = this;
        event.preventDefault();
        //
        const spinChild = jQuery36(this).find('.spin')
        const buyLoading =  jQuery36(this).find('.buy-now-loading')
        //
        const dataTrackingFrom = jQuery36(buttonBuy).attr("data-tracking-from") || "";
        // VNYL-1551 — read at click time, not when the add lands: by then the drawer has
        // opened and the mobile sticky bar may have changed state.
        const addedToCartControl = app.getAddedToCartControl(buttonBuy, dataTrackingFrom);
        const badgeShown = app.getBadgeShown(buttonBuy, addedToCartControl);
        let variantId = jQuery36(buttonBuy).attr("data-variant-id");
        variantId = utils.getShortProductVariantId(variantId);
        let isRecipient = jQuery36(buttonBuy).attr("data-is-recipient");
        const recipientEmail = jQuery36(buttonBuy).attr("data-recipient-email");
        if(buttonBuy.classList.contains('save-message')){
        isRecipient = true
        }
        // VNYL-1405 — two confirmation paths, picked by page type. Both report progress on
        // the button itself ("Adding…" -> "Added ✓") and pulse the header cart icon; they
        // differ only in the confirmation:
        //   toast  — browse-type pages (collection / shop / browse / search). The drawer
        //            stays shut so the user keeps browsing.
        //   drawer — PDP / wishlist / everything else. The drawer opens once the add lands
        //            (per the design flow: Adding… -> Added ✓ -> pulse -> drawer slides in),
        //            not on click, so it never appears for an add that turns out to fail.
        const feedback = window.VinylAddToCart;
        const useToast = !isRecipient && app.shouldToastAddToCart(dataTrackingFrom);
        // The gift-message/recipient flow keeps the legacy spinner: it drives its own modal
        // sequence and its button ("save message") isn't an add-to-cart label.
        const ownsButtonState = !!feedback && !isRecipient;
        // Adds fired from inside the open drawer only need a refresh, not an open.
        const drawerAlreadyOpen = dataTrackingFrom === 'cart-recommendation';
        const openDrawerAfterAdd = !useToast && !isRecipient && !drawerAlreadyOpen;

        if (ownsButtonState) {
            // A double-click would otherwise fire a second add while the first is still in
            // flight, and the second toast would cut the first one's timer short.
            if (feedback.isBusy(buttonBuy)) return;
            feedback.setButtonState(buttonBuy, 'adding');
        } else if (spinChild.length) {
            spinChild.css('display', 'block');
            buyLoading.attr('style', 'color: #02cba4;');
        }
        // Only the already-open drawer needs its loading state now. The rest get it from
        // vinyl:cart:refresh at the moment they open.
        if (drawerAlreadyOpen) {
            document.dispatchEvent(new CustomEvent('vinyl:cart:adding:start'));
        }
        const sendName = jQuery36(buttonBuy).attr("data-send-name")
        const message = jQuery36(buttonBuy).attr("data-message");
        const sendOn = jQuery36(buttonBuy).attr("data-send-on") || new Date().toISOString().split('T')[0];
        const dataTime =  jQuery36(buttonBuy).attr("data-time");
        const dataImageSrc = jQuery36(buttonBuy).attr("data-image-src");
        const dataLocalPrice = jQuery36(buttonBuy).attr("data-price");
        const shopifyOffset = -360;
        
        const offset = Number(shopifyOffset) + Number(new Date().getTimezoneOffset()) + Number(dataTime)
        const cardData = {
            image: dataImageSrc,
            sendName: sendName,
            price: dataLocalPrice,
        }

        // Reuse the cart the React drawer already holds (window.__vinylCart, kept current by
        // applyCartData and the early prime fetch) instead of a pre-flight GET /cart.js.
        // /cart/add.js merges quantities server-side regardless, so a rare stale snapshot
        // can't corrupt the cart — only the tracking baseline, which is acceptable. This
        // removes the second /cart.js, leaving one read per add (the post-add refresh).
        // Falls back to a fetch only when the drawer hasn't loaded a cart yet.
        const onCurrentCart = function (data) {
                if(typeof data ==="string" || data instanceof String){
                    data = JSON.parse(data);
                }
                let existItem = (data.items?.find(e=>e.id==variantId));
                const cart_number_items =  data.item_count + 1
                const currency = data.currency;
                const currencySymbol = currency === "GBP" ? "£" : "$";
                cardData['currency'] = currency;
                cardData['sb'] = currencySymbol;
                if(!existItem){
                    let cart_value = data.original_total_price / 100
                    const cart_product_sku = []
                    const cart_product_name = []
                    data.items.map(item => {
                        cart_product_sku.push(item.sku)
                        cart_product_name.push(item.title)
                    })
                    let productIds = data.items.map(item => item.product_id);
                    const previousCartProducts = data.items
                    const previousCartVariantIds = (data.items || []).map(item => item.variant_id)

                    let items
                    if (isRecipient) {
                         items = [
                            {
                                quantity: 1,
                                id: variantId,
                                properties: {
                                    'Recipient email': recipientEmail,
                                    'Message': message ,
                                    'Send on': sendOn,
                                    '__shopify_offset': offset,
                                    '__shopify_send_gift_card_to_recipient': "on",
                                    "__card_data":cardData,
                                }
                            },
                        ];
                    } else {
                         items = [
                            {
                                quantity: 1,
                                id: variantId,
                                properties:{
                                    "__card_data":cardData,
                                }
                            },
                        ];
                    }
                    jQuery36.ajax({
                        type: "POST",
                        url: window.Shopify.routes.root + "cart/add.js",
                        data: {
                            items: items,
                        },
                        success: function (data) {
                            // If user adds to cart, suppress welcome discount popup for this session
                            try {
                                sessionStorage.setItem('vinyl_welcome_discount_added_to_cart', 'true');
                                sessionStorage.removeItem('vinyl_welcome_discount_badge_enabled');
                                const badge = document.getElementById('vinyl-welcome-discount-badge');
                                if (badge) badge.style.display = 'none';
                            } catch (e) {}
                            // Stage the new line item and bump the header count first — that's
                            // what lets the drawer open already populated ("shell with known
                            // data" in the design) instead of empty-then-filling. The refresh
                            // handler never opens the modal itself, so this is also correct in
                            // toast mode, where it keeps the closed drawer in sync.
                            if (openDrawerAfterAdd || drawerAlreadyOpen || useToast) {
                                document.dispatchEvent(new CustomEvent('vinyl:cart:refresh', { detail: { addedItems: data.items } }));
                                if (useToast) {
                                    app.showAddedToCartToast(buttonBuy, data.items?.[0]);
                                } else {
                                    app.showAddedToCartDrawer(buttonBuy, openDrawerAfterAdd);
                                }
                            } else {
                                // Gift/recipient flow — opens the drawer via the toggle, as before.
                                jQuery36('#cart-toggle-button').trigger('click');
                            }
                            cart_value += data.items[0]?.original_price/100
                            if (!previousCartVariantIds.includes(data.items[0].variant_id)) {
                                !!data.items[0]?.sku && data.items[0]?.sku !== '' && cart_product_sku.push(data.items[0]?.sku)
                                cart_product_name.push(data.items[0].title)
                            }
                            const product_sku = data.items[0]?.sku
                            const product_name = data.items[0]?.title
                            const price_local = data.items[0]?.original_price/100
                            const addedProductId = data.items[0]?.product_id;
                            const addedVariantId = data.items[0]?.id;

                            if (!productIds.includes(addedProductId)) {
                                productIds.push(addedProductId)
                            }

                            let newCartProducts = [...previousCartProducts]
                            const isExisted = previousCartProducts.find(product => data.items[0]?.id === product.id)
                            if (!!isExisted) {
                                newCartProducts = previousCartProducts.map(product => {
                                    if (data.items[0]?.id === product.id) {
                                        return data.items[0];
                                    }
                                    return product;
                                })
                            } else {
                                newCartProducts = [...newCartProducts, data.items[0]]
                            }
                            jQuery36.ajax({
                                type: "GET",
                                url: PROXY_BASE_URL + `/products/get-product-by-ids?ids=${(productIds || []).join(",")}`,
                                success: function (data) {
                                    try {                                           
                                        // get list price of product from REST admin api
                                        let usdPrice = {}
                                        newCartProducts.map(product => {
                                            const fetchProduct = data.products.find(p => Number(p.id) === Number(product.product_id))
                                            const variant = fetchProduct.variants.find(v => Number(v.id) === product.variant_id)
                                            if (!!variant) {
                                                usdPrice[variant.id] = Number(variant.price);
                                            }
                                        })
                                        // map to products in cart to calculate total price USD
                                        let cart_value_usd = newCartProducts.reduce((pre, curr) => {
                                            const price = curr.quantity * usdPrice[curr.id]
                                            return pre + price
                                        }, 0);
                                        cart_value_usd = Number(cart_value_usd).toFixed(2)

                                        const price_usd = usdPrice[addedVariantId]
                                        const addedProduct = data.products.find(p => Number(p.id) === Number(addedProductId))
                                        const artist = addedProduct?.artist || ''
                                        const jaxstaReleaseId = addedProduct?.jaxstaReleaseId || ''
                                        const productType = (addedProduct?.product_type || '')?.toLowerCase()
                                        const productVendor = addedProduct?.vendor || ''
                                        const tags = Array.isArray(addedProduct?.tags) ? addedProduct?.tags : (addedProduct?.tags || '').split(',')
                                        const isFramedVinyl = tags.some(tag => tag.toLowerCase().trim() === 'framed vinyl')
                                        const isMerch = tags.some(tag => tag.toLowerCase().trim() === 'merch')
                                        const isVinyl = tags.some(tag => tag.toLowerCase().trim() === 'vinyl')
                                        const isCD = tags.some(tag => tag.toLowerCase().trim() === 'cd')
                                        const isGiftCard = tags.some(tag => tag.toLowerCase().trim() === 'gift card')

                                        let product_category = 'unknown'

                                        if (productType === 'vinyl' || isVinyl) {
                                            product_category = 'vinyl'
                                        } else if (productType === 'cd' || isCD) {
                                            product_category = 'cd'
                                        } else if (productType === 'gift card' || isGiftCard) {
                                            product_category = 'gift_card'
                                        }

                                        if (isFramedVinyl) {
                                            product_category = "framed_vinyl"
                                        }

                                        if (isMerch) {
                                            product_category = "merch"
                                        }

                                        // Where the product was added to cart from. Modal/context
                                        // sources map to explicit closed-list values; every other
                                        // source (grids/carousels, product page, recommendations)
                                        // derives from the current page URL.
                                        let added_to_cart_from;
                                        switch (dataTrackingFrom) {
                                            case "cart-recommendation":
                                                added_to_cart_from = "cart";
                                                break;
                                            case "perfect-pairings-modal":
                                                added_to_cart_from = "perfect_pairings_modal";
                                                break;
                                            case "for-you":
                                                added_to_cart_from = "custom-collection";
                                                break;
                                            default:
                                                added_to_cart_from = app.getPageNameFromUrl();
                                        }

                                        let trackingPayload = {
                                            cart_number_items,
                                            cart_product_sku,
                                            cart_product_name,
                                            cart_value_usd: Number(cart_value_usd),
                                            cart_value_local: cart_value,
                                            product_sku,
                                            product_name,
                                            price_usd,
                                            price_local,
                                            currency_local: currency,
                                            on_product_page: dataTrackingFrom === "detail-product",
                                            recommended_product: dataTrackingFrom === "product-recommendation",
                                            jaxsta_release_linked: !!jaxstaReleaseId,
                                            jaxsta_artist_linked: !!artist,
                                            product_category,
                                            supplier_name: productVendor,
                                            added_to_cart_from,
                                        };
                                        // VNYL-1551 — which control was tapped, and the PDP's
                                        // badges when it was the PDP's own buy button.
                                        if (addedToCartControl) {
                                            trackingPayload.added_to_cart_control = addedToCartControl;
                                        }
                                        if (badgeShown) {
                                            trackingPayload.badge_shown = badgeShown;
                                        }
                                        if(dataTrackingFrom === "product-recommendation"){
                                            trackingPayload = {
                                                ...trackingPayload,
                                                recommended_product: true,
                                                recommendation_type: 'recommendations_carousel',
                                                recommendation_placement: 'product',
                                            }
                                        }
                                        if(dataTrackingFrom === "perfect-pairings-modal"){
                                            trackingPayload = {
                                                ...trackingPayload,
                                                recommended_product: true,
                                                recommendation_type: 'perfect_pairings',
                                                recommendation_placement: 'perfect_pairings_modal'
                                            }
                                        }
                                        if(dataTrackingFrom === "perfect-pairings-item"){
                                            trackingPayload = {
                                                ...trackingPayload,
                                                recommended_product: true,
                                                recommendation_type: 'perfect_pairings',
                                                recommendation_placement: 'product',
                                            }
                                        }
                                        if(dataTrackingFrom === "for-you"){
                                            trackingPayload = {
                                                ...trackingPayload,
                                                recommended_product: true,
                                                recommendation_type: 'custom-collection',
                                                recommendation_placement: 'custom-collection',
                                            }
                                        }
                                        if(dataTrackingFrom === "cart-recommendation"){
                                            trackingPayload = {
                                                ...trackingPayload,
                                                recommended_product: true,
                                                recommendation_type: 'recommendations_carousel',
                                                recommendation_placement: 'cart',
                                            }
                                        }
                                        utils.mixpanelRetryWrapper.track('Added To Cart', trackingPayload);
                                    } catch (error) {
                                        console.log("Add to cart tracking error");
                                        console.error(error);
                                    }
                                }
                            })
                            app.fetchProductListByAjax(newCartProducts.map(p=>p.handle)).then(products => {
                                //get compare_at_price from products and add to productsInCart 
                                const productsInCart = newCartProducts.map(product => {
                                    const fetchProduct = products.find(p => Number(p.id) === Number(product.product_id))
                                    const variant = fetchProduct.variants.find(v => Number(v.id) === product.variant_id)
                                    if (!!variant) {
                                        product.compare_at_price = variant.compare_at_price;
                                    }
                                    return product;
                                });
                                // sent event to airship: products_in_cart: product_name, price_local, compare_at_price_local, product_url, product_image_url, currency_local, product_quantity
                                const productsInCartBody = productsInCart.reduce((pre, curr) => {
                                    pre.push({
                                        product_name: curr.title,
                                        price_local: curr.original_price / 100,
                                        compare_at_price_local: curr.compare_at_price / 100,
                                        product_url: window.location.origin + `/products/${curr.handle}`,
                                        product_image_url: curr.image,
                                        currency_local: currency,
                                        product_quantity: curr.quantity,
                                        artist: curr.title.split(" - ")[0],
                                        handle: curr.handle,
                                        currency_symbol: currency === "GBP" ? "£" : "$",
                                    });
                                    return pre;
                                },[]);
                                //caculate cartSubtotalLocal by sum all original price of products in cart
                                const cartSubtotalLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.original_line_price / 100
                                }, 0);
                                //caculate cartTotalLocal by sum all final price of products in cart
                                const cartTotalLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.final_line_price / 100
                                }, 0);
                                //caculate cartDiscountLocal by sum all total_discount of products in cart
                                const cartDiscountLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.total_discount / 100
                                }, 0);
                                const checkoutUrl = `${window.location.origin}/checkouts/cn/${utils.getCookie('cart').split('?')[0]}`
                                const airshipAddToCartEventBody = {
                                    productsInCart: productsInCartBody,
                                    checkoutUrl,
                                    cartSubtotalLocal,
                                    cartTotalLocal,
                                    cartDiscountLocal,
                                }
                                airship.triggerAddedToCartEventInAirship(airshipAddToCartEventBody);
                            });
                            // Legacy spinner teardown, skipped when we own the button markup: writeLabel()
                            // replaced the .buy-now contents, so spinChild is detached and styling
                            // buyLoading here would fight setButtonState's own reset.
                            if (!ownsButtonState && spinChild.length) {
                                spinChild.css('display', 'none');
                                buyLoading.attr('style', 'color: #0C0C0C;');
                            }
                        },
                        error: function (error) {
                            console.log(error);
                            // Drawer was opened on click — clear its loading state since the add failed.
                            document.dispatchEvent(new CustomEvent('vinyl:cart:adding:end'));
                            // Put the button back to its original label. Note the drawer never
                            // opened for this add, so there is no stale drawer to close.
                            if (ownsButtonState) {
                                feedback.setButtonState(buttonBuy, 'reset');
                            }
                            // Legacy spinner teardown, skipped when we own the button markup: writeLabel()
                            // replaced the .buy-now contents, so spinChild is detached and styling
                            // buyLoading here would fight setButtonState's own reset.
                            if (!ownsButtonState && spinChild.length) {
                                spinChild.css('display', 'none');
                                buyLoading.attr('style', 'color: #0C0C0C;');
                            }
                        },
                        dataType: "json",
                    });
                }else{
                    let data = {};
                    data[existItem.key] = existItem.quantity + 1;
                    if(isRecipient) {
                        data['properties'] = {
                            "Recipient email": recipientEmail,
                            "Message": message,
                            "Send on": sendOn,
                            '__shopify_offset': offset,
                            "__shopify_send_gift_card_to_recipient": "on",
                            "__card_data":cardData,
                        }
                    }else{
                        // data['properties'] = {
                        //     "__card_data":cardData,
                        // }
                    }

                    jQuery36.ajax({
                        type: "POST",
                        url: window.Shopify.routes.root + "cart/update.js",
                        contentType: "application/json",
                        dataType: 'json',
                        data: JSON.stringify({
                            updates: data
                        }),
                        success: function (data) {
                            let productsInCart = data.items;
                            if (openDrawerAfterAdd || drawerAlreadyOpen || useToast) {
                                // Pass the full updated cart from update.js so the cart component
                                // can apply it directly — no extra /cart.js round-trip needed.
                                document.dispatchEvent(new CustomEvent('vinyl:cart:refresh', { detail: { cartData: data } }));
                                if (useToast) {
                                    // update.js returns the whole cart, so pick out the line we bumped.
                                    app.showAddedToCartToast(buttonBuy, (data.items || []).find(item => String(item.id) === String(variantId)));
                                } else {
                                    app.showAddedToCartDrawer(buttonBuy, openDrawerAfterAdd);
                                }
                            } else {
                                // Gift/recipient flow — opens the drawer via the toggle, as before.
                                jQuery36('#cart-toggle-button').trigger('click');
                            }
                            app.fetchProductListByAjax(productsInCart.map(p=>p.handle)).then(products => {
                                //get compare_at_price from products and add to productsInCart 
                                productsInCart = productsInCart.map(product => {
                                    const fetchProduct = products.find(p => Number(p.id) === Number(product.product_id))
                                    const variant = fetchProduct.variants.find(v => Number(v.id) === product.variant_id)
                                    if (!!variant) {
                                        product.compare_at_price = variant.compare_at_price;
                                    }
                                    return product;
                                });
                                // sent event to airship: products_in_cart: product_name, price_local, compare_at_price_local, product_url, product_image_url, currency_local, product_quantity
                                const productsInCartBody = productsInCart.reduce((pre, curr) => {
                                    pre.push({
                                        product_name: curr.title,
                                        price_local: curr.original_price / 100,
                                        compare_at_price_local: curr.compare_at_price / 100,
                                        product_url: window.location.origin + `/products/${curr.handle}`,
                                        product_image_url: curr.image,
                                        currency_local: currency,
                                        product_quantity: curr.quantity,
                                        artist: curr.title.split(" - ")[0],
                                        handle: curr.handle,
                                        currency_symbol: currency === "GBP" ? "£" : "$",
                                    });
                                    return pre;
                                },[]);
                                //caculate cartSubtotalLocal by sum all original price of products in cart
                                const cartSubtotalLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.original_line_price / 100
                                }, 0);
                                //caculate cartTotalLocal by sum all final price of products in cart
                                const cartTotalLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.final_line_price / 100
                                }, 0);
                                //caculate cartDiscountLocal by sum all total_discount of products in cart
                                const cartDiscountLocal = productsInCart.reduce((pre, curr) => {
                                    return pre + curr.total_discount / 100
                                }, 0);
                                const checkoutUrl = `${window.location.origin}/checkouts/cn/${utils.getCookie('cart').split('?')[0]}`
                                const airshipAddToCartEventBody = {
                                    productsInCart: productsInCartBody,
                                    checkoutUrl,
                                    cartSubtotalLocal,
                                    cartTotalLocal,
                                    cartDiscountLocal,
                                }
                                airship.triggerAddedToCartEventInAirship(airshipAddToCartEventBody);
                            });
                            // Legacy spinner teardown, skipped when we own the button markup: writeLabel()
                            // replaced the .buy-now contents, so spinChild is detached and styling
                            // buyLoading here would fight setButtonState's own reset.
                            if (!ownsButtonState && spinChild.length) {
                                spinChild.css('display', 'none');
                                buyLoading.attr('style', 'color: #0C0C0C;');
                            }
                        },
                        error: function (error) {
                            console.log(error);
                            // Drawer was opened on click — clear its loading state since the add failed.
                            document.dispatchEvent(new CustomEvent('vinyl:cart:adding:end'));
                            // Put the button back to its original label. Note the drawer never
                            // opened for this add, so there is no stale drawer to close.
                            if (ownsButtonState) {
                                feedback.setButtonState(buttonBuy, 'reset');
                            }
                            // Legacy spinner teardown, skipped when we own the button markup: writeLabel()
                            // replaced the .buy-now contents, so spinChild is detached and styling
                            // buyLoading here would fight setButtonState's own reset.
                            if (!ownsButtonState && spinChild.length) {
                                spinChild.css('display', 'none');
                                buyLoading.attr('style', 'color: #0C0C0C;');
                            }
                        },
                        dataType: "json",
                    });
                }
        };
        const __cachedCart = window.__vinylCart;
        if (__cachedCart && Array.isArray(__cachedCart.items)) {
            // Drawer already has the current cart — skip the network round-trip.
            onCurrentCart(__cachedCart);
        } else {
            jQuery36.ajax({
                type: "GET",
                url: window.Shopify.routes.root + "cart.js",
                success: onCurrentCart,
                error: function (error) {
                    console.log('[Add to cart] cart.js fallback failed', error);
                    // Drawer may have been opened on click — clear its loading state.
                    document.dispatchEvent(new CustomEvent('vinyl:cart:adding:end'));
                    // Put the button back to its original label.
                    if (ownsButtonState) {
                        feedback.setButtonState(buttonBuy, 'reset');
                    }
                    // Legacy spinner teardown, skipped when we own the button markup: writeLabel()
                    // replaced the .buy-now contents, so spinChild is detached and styling
                    // buyLoading here would fight setButtonState's own reset.
                    if (!ownsButtonState && spinChild.length) {
                        spinChild.css('display', 'none');
                        buyLoading.attr('style', 'color: #0C0C0C;');
                    }
                },
            });
        }

    },
    // Session cache of Shopify product JSON keyed by handle. compare_at_price / prices are
    // stable within a session (currency doesn't change), so the tracking flow previously
    // refetched products/{handle}.js for EVERY cart item on EVERY add (N calls/add). With
    // the cache, items added on prior adds are reused and only the newly added handle is
    // fetched — dropping the per-add count from N to ~1.
    _productJsonCache: {},
    fetchProductListByAjax: async function (productHandles=[]) {
        try {
            const cache = app._productJsonCache;
            return await Promise.all(
                productHandles.map(async (handle) => {
                    if (cache[handle]) return cache[handle];
                    try {
                        const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`);
                        if (!response.ok) return undefined;
                        const data = await response.json();
                        cache[handle] = data;
                        return data;
                    } catch (e) {
                        return undefined;
                    }
                })
            );
        } catch (err) {
            console.log(err)
        }
        return null;
    },
    addToCart: function (target) {
        jQuery36(".button-buy").each(function () {
            let buttonBuy = this;
            buttonBuy.addEventListener("click", app.handleBuyClick);
        });
    },
    removeListenerAddToCart: function () {
        jQuery36(".button-buy").each(function () {
            let buttonBuy = this;
            buttonBuy.removeEventListener("click", app.handleBuyClick);
        });
    },
    handleDiscountUrl: function(){
        let origin = window.location.origin;
        let pathname = window.location.pathname;
        let search = window.location.search;
        const regex = /(discount=)\w+/g;
        const found = search.match(regex)||[];
        if (found.length===0) return;
        let discountCode = found[0]?.split("=").at(1);
        window.location.replace(`${origin}/discount/${discountCode}?redirect=${pathname}`)
    },
    handleUrlFromTheBrag: function(){
        try {
            //get query string from url
            const queryString = window.location.search;
            //if utm_campaign is the_brag_ads, show popup which has id is discount-popup, use js and boostrap
            if(queryString.includes("utm_campaign=the_brag_ads")){
                const discountPopup = new bootstrap.Modal('#discount-popup', {
                    keyboard: false
                })
                discountPopup.show();
                sessionStorage.setItem('hideWidget', true);
            }
        } catch (error) {
            console.error(`[handleUrlFromTheBrag] error: ${error} - ${error.stack}`);
        }
    },
    handleCanadaPostStrikePopup: function(){
        try {
            // find popup with id is canada-post-strike-popup, if it exists, show it after 7 seconds
            const canadaPostStrikePopup = document.getElementById('canada-post-strike-popup');
            if (canadaPostStrikePopup) {
                const canadaPostStrikeModal = new bootstrap.Modal(canadaPostStrikePopup, {
                    keyboard: false
                });
                // check if user has closed the popup before
                const hasClosedPopup = sessionStorage.getItem('hasClosedCanadaPostStrikePopup');
                if (!hasClosedPopup) {
                    setTimeout(() => {
                        canadaPostStrikeModal.show();
                    }, 7000);
                }
                // add event listener to popup is hidden
                canadaPostStrikeModal._element.addEventListener('hidden.bs.modal', () => {
                    // set sessionStorage to remember that user has closed the popup
                    sessionStorage.setItem('hasClosedCanadaPostStrikePopup', true);
                });
                
            }
        } catch (error) {
            console.error(`[handleCanadaPostStrikePopup] error: ${error} - ${error.stack}`);
        }
    },
    hanldeAccordion: function () {

        const level2 = document.querySelector('.shop-navbar-level-2');
        const level3 = document.querySelector('.shop-navbar-level-3');
        const level1ToggleList = document.querySelectorAll('.shop-navbar-level-1 a');
        const level2ToggleList = document.querySelectorAll('.shop-navbar-level-2 a');
        const defaultPreviewLevel2 = document.getElementById("collapseDefaultLevel2");
        const defaultPreviewLevel3 = document.getElementById("collapseDefaultLevel3");
    
        const level2PreviewContent = Array.from(document.querySelectorAll('.shop-navbar-level-2 .shop-navbar-preview-content'));
        const level2SubmenuContent = Array.from(document.querySelectorAll('.shop-navbar-level-2 .shop-navbar-submenu-content'));
        const level2CollapsePreviewElements = level2PreviewContent.map(item=>item.parentElement);
    
        //style preview
        let stylePreview = {
          hideDefaultPreviewLevel3:()=>{
            defaultPreviewLevel3.style.display = "none";
            defaultPreviewLevel3.style.opacity = "0.4";
            defaultPreviewLevel3.style.position = "absolute";
            defaultPreviewLevel3.style.visibility="hidden";
          },
          showDefaultPreviewLevel3:()=>{
            defaultPreviewLevel3.style.display = "block";
            defaultPreviewLevel3.style.opacity = "1";
            defaultPreviewLevel3.style.position = "static";
            defaultPreviewLevel3.style.visibility="visible";
          },
          hideDefaultPreviewLevel2:(preview = defaultPreviewLevel2)=>{
            if(!preview) return;
            preview.style.display = "none";
            preview.style.opacity = "0.4";
            preview.style.position = "absolute";
            preview.style.visibility="hidden";
          },
          showDefaultPreviewLevel2:(preview = defaultPreviewLevel2)=>{
            if(!preview) return;
            preview.style.display = "block";
            preview.style.opacity = "1";
            preview.style.position = "static";
            preview.style.visibility="visible";
          },
          flexGrowLevel2:()=>{
            level2.style['flex-grow']=1;
            level3.style['flex-grow']=0;
          },
          flexGrowLevel3:()=>{
            level2.style['flex-grow']=0;
            level3.style['flex-grow']=1;
          }
        }
        //hover to toggle
        let lastCollapseLv2 = null;
        let lastCollapseLv3 = null;
        const handleMouseoverLv1Throttle = utils.throttle(async (toggleItem)=>{
            // Each top-level menu (VINYL, GENRE, GIFTS) has its own default preview, and only
            // GIFTS' is #collapseDefaultLevel2. Target the one in the hovered menu, otherwise
            // hovering a VINYL item hid the GIFTS preview until the next page load.
            const defaultPreview = toggleItem.closest('.shop-navbar')?.querySelector('[id$="DefaultLevel2"]');
            if(!toggleItem.hasAttribute('data-bs-toggle')){
                stylePreview.showDefaultPreviewLevel2(defaultPreview);
                if(lastCollapseLv2){
                    lastCollapseLv2.hide();
                }
                if(lastCollapseLv3){
                    lastCollapseLv3.hide();
                }
            }
            if(toggleItem.classList.contains('collapsed')&&toggleItem.getAttribute('href').match(/^#collapse/)){
                const collapseId = toggleItem.getAttribute('href');
                const collapseEl = document.querySelector(collapseId);
                const collapseObject = new bootstrap.Collapse(collapseEl);
                await collapseObject.toggle();
                stylePreview.hideDefaultPreviewLevel2(defaultPreview);
                lastCollapseLv2 = collapseObject;
            }
        },200);
        level1ToggleList.forEach((toggleItem, key)=>{
          toggleItem.addEventListener('mouseover',
            ()=>handleMouseoverLv1Throttle(toggleItem)
          );
          toggleItem.addEventListener('click', (event)=>{
            const collapseId = toggleItem.getAttribute('href');
            const collapseEl = document.querySelector(collapseId);
            const collapseObject = new bootstrap.Collapse(collapseEl);
            collapseObject.show();
            const collapseUrl = toggleItem.getAttribute('open-href');
            window.location.replace(collapseUrl);
          })
        })

        const handleMouseoverLv2Throttle = utils.throttle(async (toggleItem)=>{
            if(toggleItem.classList.contains('collapsed')&&toggleItem.getAttribute('href').match(/^#collapse-sub/)){
                const collapseId = toggleItem.getAttribute('href');
                const collapseEl = document.querySelector(collapseId);
                const collapseObject = new bootstrap.Collapse(collapseEl);
                collapseObject.toggle();
                lastCollapseLv3 = collapseObject;
            }
        },200);
        level2ToggleList.forEach((toggleItem, key)=>{
          toggleItem.addEventListener('mouseover',()=>handleMouseoverLv2Throttle(toggleItem)
          )
          toggleItem.addEventListener('click', (event)=>{
            const collapseId = toggleItem.getAttribute('href');
            const collapseEl = document.querySelector(collapseId);
            const collapseObject = new bootstrap.Collapse(collapseEl);
            collapseObject.show();
            const collapseUrl = toggleItem.getAttribute('open-href');
            window.location.replace(collapseUrl);
          })
        })
        //listen if level 2 content is preview which has ready shown, hide level3
        let lv2State = 0;
        let lv3State = 0;
        // level2CollapsePreviewElements.forEach((element)=>{
        //   element.addEventListener('shown.bs.collapse',()=>{
        //     lv2State=1;
        //     stylePreview.hideDefaultPreviewLevel2();
        //     stylePreview.flexGrowLevel2();
        //   })
        //   element.addEventListener('hidden.bs.collapse',()=>{
        //     stylePreview.showDefaultPreviewLevel2();
        //     if(lv3State==0){
        //         stylePreview.flexGrowLevel2();
        //     }else{
        //         stylePreview.flexGrowLevel3();
        //     }
        //   })
        // })
        // const level2CollapseSubmenuElements = level2SubmenuContent.map(item=>item.parentElement);
        // level2CollapseSubmenuElements.forEach((element)=>{
        //   element.addEventListener('shown.bs.collapse',()=>{
        //     lv3State=1;
        //     stylePreview.showDefaultPreviewLevel3();
        //     stylePreview.hideDefaultPreviewLevel2();
        //     stylePreview.flexGrowLevel3();
        //   })
        //   element.addEventListener('hide.bs.collapse',()=>{
        //     lv3State=0;
        //     stylePreview.hideDefaultPreviewLevel3();
        //     stylePreview.showDefaultPreviewLevel2();
        //     stylePreview.flexGrowLevel2();
        //   })
        // })
        // const level3PreviewContent = Array.from(document.querySelectorAll('.shop-navbar-level-3 .shop-navbar-preview-content'));
        // const level3CollapsePreviewElements = level3PreviewContent.map(item=>item.parentElement);
        
        // level3CollapsePreviewElements.forEach((element)=>{
        //   element.addEventListener('shown.bs.collapse',()=>{
        //     stylePreview.hideDefaultPreviewLevel3();
        //   })
        // })
      },
      checkContainerOffsetRight: function () {
        var container = jQuery36(".calc-offset-right");
        var headerContainer = jQuery36("#siteHeader > .header-inner > .container");
        var right = (jQuery36(window).width() - (headerContainer.offset().left + headerContainer.outerWidth())) + 15;
        if (isTableAndDesktopScreen()) {
          container.css("padding-right", right);
        } else {
          container.removeAttr("style");
        }
      },
    initializeTooltips: function (){
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    },
    handleOldArticleUrl: function(){
        let origin = window.location.origin;
        let pathname = window.location.pathname;
        const regex = /(^\/blog\/)/g;
        const found = pathname.match(regex)||[];
        if (found.length===0) return;
        pathname = (pathname.replace(regex,"/blogs/blog/"));
        window.location.replace(`${origin}${pathname}`)
    },
    initDateTimePicker: function (){
        jQuery36( "#giftDatePicker" ).datetimepicker({
            date: new Date(),
            viewMode: 'YMDHM',
            //date selection event
            onDateChange: function() {
            },
            //clear button click event
            onClear: function() {
                const giftDeliveryDate = document.querySelector('#giftDeliveryDate')
                giftDeliveryDate.value = ""
                const datePicker = document.querySelector('#giftDatePicker')
                datePicker.classList.add('d-none')
                datePicker.classList.remove('d-block')
                const buttonsBuy = document.querySelectorAll('.gift-page .button-buy')
                buttonsBuy.forEach(btn => {
                    btn.setAttribute("data-send-on", null)
                })
            },
            //ok button click event
            onOk: function() {
                const giftDeliveryDate = document.querySelector('#giftDeliveryDate')
                const date = this.getValue().toISOString().split('T')[0];
                const year = date.split("-")[0];
                const month = date.split("-")[1];
                const day = date.split("-")[2];
                const timeType = document.getElementById('selectTimeTypeGiftCard')
                let hours = Number(document.getElementById('timeSelectionGiftCard').value)
                if(timeType.value === 'PM') {
                    hours = hours === 12 ? 0 : hours+ 12
                }
                const minutes = 0
                const formattedDate = `${day}-${month}-${year}`
                const formattedTime = hours + ':' + '00'
                giftDeliveryDate.value = `${formattedDate} ${formattedTime}`
                const datePicker = document.querySelector('#giftDatePicker')
                datePicker.classList.add('d-none')
                datePicker.classList.remove('d-block')
                const buttonsBuy = document.querySelectorAll('.gift-page .button-buy')
                buttonsBuy.forEach(btn => {
                    btn.setAttribute("data-send-on",date)
                    btn.setAttribute("data-time", hours * 60 + minutes)
                })
                
            },
            //close button click event
            onClose: function() {
                console.log('onClose', this.getValue());
            }
            
        });
    },
    wishlistUpdater: (() => {
        const wishlistChange = {};
        let interval = null;
        const Change = {
            'ADD':1,
            'REMOVE':-1
        }
        /**
         * 
         * @param {*} customerId 
         * @param {*} productId 
         * @param {change} change is 1 or -1
         * @returns -1 if invalid change
         */
        function updateProductToWishlist(productId, change) {
            if(change!==Change.ADD && change!==Change.REMOVE){
                console.error('[updateProductToWishlist] Invalid input');
                return -1;
            }
            if (wishlistChange.hasOwnProperty(productId)) {
                const value = wishlistChange[productId];
                const nextValue = value+change;
                if(nextValue>1 || nextValue<-1) {
                    console.error('[updateProductToWishlist] Invalid next value');
                    return -1;
                }
                wishlistChange[productId] = nextValue;
            } else {
                wishlistChange[productId] = change;
            }
            afterHandle();
            return 1;
        }
        async function updateToShopify(){
            const commitWishlistChange = {...wishlistChange};
            for (const key in wishlistChange) {
                if (Object.hasOwnProperty.call(wishlistChange, key)) {
                    delete wishlistChange[key];
                }
            }
            const customerId = "gid://shopify/Customer/" + shopifyCustomer.customerId;
            try {
                (async ()=>{
                    const response = await fetch(PROXY_BASE_URL+'/customer/wishlist/product', {
                    method: 'PUT',
                    headers: {
                        ...utils.customerRequestHeaders(),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ customerId, wishlistChange:commitWishlistChange }),
                    });
                    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                })();
                (async ()=>{
                    const appResponse = await fetch(`${window.location.origin}/apps/${APP_PROXY_NAME}/app/wishlist`, {
                        method: 'PUT',
                        headers: {
                            ...utils.customerRequestHeaders(),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ customerId, wishlistChange:commitWishlistChange }),
                    });
                    if (!appResponse.ok) throw new Error(`HTTP error! Status: ${appResponse.status}`);
                })();
            } catch (error) {
                console.error('Fetch error:', error.message);
                //If false, merge commit change to current change which is renew when stating fetch
                for (const productId in commitWishlistChange) {
                    if (Object.hasOwnProperty.call(commitWishlistChange, productId)) {
                        const change = commitWishlistChange[productId];
                        if(wishlistChange.hasOwnProperty(productId)){
                            const currentValue = wishlistChange[productId];
                            wishlistChange[productId] = Math.sign(change + currentValue);
                        }else{
                            wishlistChange[productId] = change;
                        }
                    }
                }
            }
        }
        function createInterval(customerId, customerAccessToken) {
            if (!interval) {
                interval = setInterval(() => {
                    if (Object.keys(wishlistChange).length == 0) {
                        clearInterval(interval);
                        interval = null;
                    } else {
                        updateToShopify(customerId, customerAccessToken);
                    }
                }, 2000);
            }
        }
        function afterHandle() {
            createInterval();
        }
        function getWishlistChange(){
            return {...wishlistChange};
        }
        return {
            updateProductToWishlist,
            Change,
            getWishlistChange,
        }
    })(),
    submitLoginForm: (email, password)=>{
        const formData = new FormData();
        formData.append("form_type", "customer_login");
        formData.append("utf8", "✓");
        formData.append("return_to", "/account");
        formData.append("customer[email]", email);
        formData.append("customer[password]", password);
        fetch('/account/login',{
            method: 'post',
            body: new URLSearchParams(formData),
            redirect:"follow",
        }).then((response)=>{
            if(!response.ok){
                throw new Error('Login fail');
            }
            document.location.href = '/account';
          }).catch((error)=>{
            throw new Error(error.message);
          });
    },
    clearLoginModalStorage: () => {
        const LOGIN_MODAL_STORAGE = {
            collection: "login_modal_collection",
            creator: "login_modal_page_creators",
            merch: "login_modal_collection_merch",
            search: "login_modal_search",
            shop: "login_modal_page_shop",
        };
        Object.keys(LOGIN_MODAL_STORAGE).forEach((key) => {
          localStorage.removeItem(LOGIN_MODAL_STORAGE[key]);
        });
        localStorage.removeItem("scroll_position");
        localStorage.removeItem("wish_list_choose_item");
        localStorage.removeItem("vinyl_login_redirect");
        localStorage.removeItem("vinyl_login_modal_date");
        localStorage.removeItem("vinyl_post_login_path");
        localStorage.removeItem("vinyl_post_login_cart");
    },
    getPageNameFromUrl: (url)=>{
        const path = new URL(url || window.location.href).pathname;
        if (path === "/") {
            return "home";
        } else if (path.includes("pages/shop")) {
            return "shop";
        } else if (path.includes("pages/zine")) {
            return "blog-home";
        } else if (path === "/collections") {
            return "collections-home";
        } else if (path.includes("collections")) {
            return "collection";
        } else if (path.includes("/products")) {
            return "product";
        } else if (path === "/pages/faqs") {
            return "faq";
        } else if (path === "/blogs/blog") {
            return "blog-article";
        } else if (path.includes("/pages/creators")) {
            return "creator";
        } else if (path.includes("/account")) {
            return "account";
        } else if (path.includes("/pages/record-of-the-week")) {
            return "rotw";
        } else if (path.includes("/search")) {
            return  "search";
        } else if (path === "/pages/about-us") {
            return "about-us";
        } else if (path === "/pages/terms-of-service") {
            return "terms-of-service";
        } else if (path === "/pages/refund-policy") {
            return "refund-policy";
        } else if (path === "/pages/shipping-policy") {
            return "shipping-policy";
        } else if (path === "/pages/privacy-policy") {
            return "privacy-policy";
        }
        return path || "unknown";
    },
    // VNYL-1405 — page types where adding to cart shows a toast instead of opening the
    // cart drawer. The user is browsing and adding without visiting a PDP, so the drawer
    // interrupts the flow. PDPs and the wishlist page are deliberately absent: there the
    // drawer is the confirmation.
    TOAST_ADD_TO_CART_PAGES: ["collection", "collections-home", "shop", "search"],
    // Sources that live inside an already-open drawer or modal. That surrounding UI is
    // itself the confirmation, so a toast would be redundant (and would sit behind it).
    NO_TOAST_TRACKING_SOURCES: ["cart-recommendation", "perfect-pairings-modal", "perfect-pairings-item"],
    // VNYL-1551 — `added_to_cart_control` (closed list): which add-to-cart control the
    // shopper tapped. Kept separate from `added_to_cart_from`, which is the page type.
    // An unknown source returns undefined so the property is left off — an empty value
    // means a new button that still needs mapping here.
    ADDED_TO_CART_CONTROL_BY_SOURCE: {
        "detail-product": "buy_box",
        "product-recommendation": "recommendation",
        "perfect-pairings-item": "recommendation",
        "perfect-pairings-modal": "recommendation",
        "for-you": "recommendation",
        "cart-recommendation": "cart_drawer",
        "": "product_card",
    },
    getAddedToCartControl: function (buttonBuy, dataTrackingFrom) {
        // The PDP buy button pinned to the bottom on mobile (v2), or the desktop float bar
        // (v1 / merch PDP). On v2 the pinned bar is the buy box's own button, so the class
        // has to be read at click time.
        if (buttonBuy.closest && buttonBuy.closest(".pdv2-cta--stuck, .float-buy-button")) {
            return "sticky_bar";
        }
        // Gift card PDP (product.gifting): the add fires from the gift-message modal's
        // Save / Skip buttons, which carry no data-tracking-from. Which buy button opened
        // the modal isn't known here, so it counts as the buy box.
        if (buttonBuy.closest && buttonBuy.closest(".gift-modal-action")) {
            return "buy_box";
        }
        return app.ADDED_TO_CART_CONTROL_BY_SOURCE[dataTrackingFrom];
    },
    // VNYL-1551 — `badge_shown` on Added To Cart, only for the PDP's own buy button: on a
    // recommendation the page's badges belong to a different product.
    getBadgeShown: function (buttonBuy, addedToCartControl) {
        if (addedToCartControl !== "buy_box" && addedToCartControl !== "sticky_bar") return undefined;
        const raw = buttonBuy.getAttribute && buttonBuy.getAttribute("data-badge-shown");
        if (!raw) return undefined;
        try {
            const badges = JSON.parse(raw);
            return Array.isArray(badges) && badges.length ? badges : undefined;
        } catch (e) {
            return undefined;
        }
    },
    shouldToastAddToCart: function (dataTrackingFrom) {
        if (!window.VinylAddToCart) return false;
        if (app.NO_TOAST_TRACKING_SOURCES.includes(dataTrackingFrom)) return false;
        // An add made while the drawer happens to be open should refresh the drawer in
        // place rather than toast behind it.
        const cartModalEl = document.getElementById('myCartModal');
        if (cartModalEl && cartModalEl.classList.contains('show')) return false;
        return app.TOAST_ADD_TO_CART_PAGES.includes(app.getPageNameFromUrl());
    },
    // VNYL-1405 toast path: button flips to "Added ✓", the header cart icon pulses, and the
    // toast slides in with a View CTA. The drawer stays closed.
    showAddedToCartToast: function (buttonBuy, lineItem) {
        const feedback = window.VinylAddToCart;
        if (!feedback) return;
        feedback.setButtonState(buttonBuy, 'added');
        feedback.pulseCartIcon();
        feedback.showToast({
            title: lineItem?.product_title || lineItem?.title || '',
            imageUrl: lineItem?.image || lineItem?.featured_image?.url || '',
            // VNYL-1474: flag non-Alliance vendors so the toast notes separate shipping.
            separateShipping: (lineItem?.vendor || '') !== 'Alliance Entertainment',
        });
    },
    // VNYL-1405 drawer path (PDP / wishlist): button flips to "Added ✓", the header cart icon
    // pulses, then the drawer slides in. vinyl:cart:refresh has already staged the new line
    // item and bumped the count, so it opens showing known data with its busy state standing
    // in for the server-side totals still in flight.
    //
    // openDrawer is false when the add came from inside the drawer — it's already on screen.
    showAddedToCartDrawer: function (buttonBuy, openDrawer) {
        const feedback = window.VinylAddToCart;
        if (feedback) {
            feedback.setButtonState(buttonBuy, 'added');
            feedback.pulseCartIcon();
        }
        if (!openDrawer) return;
        const cartModalEl = document.getElementById('myCartModal');
        if (!cartModalEl || cartModalEl.classList.contains('show')) return;
        // Open via the Modal API rather than clicking #cart-toggle-button: the toggle fires
        // the React `clickCart` effect, which re-fetches /cart.js on open — a redundant third
        // read on top of the pre-flight and the post-add refresh. onClickCart() preserves the
        // mobile back-button history entry the toggle would have pushed.
        app.onClickCart();
        bootstrap.Modal.getOrCreateInstance(cartModalEl).show();
    },
    getShopifyRawId: function (shopifyId, type = ShopifyIdType.Product) {
        if (!shopifyId) return shopifyId;
        
        return `${shopifyId}`.includes(`shopify/${type}`)
            ? shopifyId
            : `gid://shopify/${type}/${shopifyId}`;
    },
    getShopifyNumberId: function (shopifyId, type = ShopifyIdType.Product) {
        if (!shopifyId || !`${shopifyId}`.includes(`shopify/${type}`)) return shopifyId;
      
        const [_, numberId] = shopifyId.split(`shopify/${type}/`);
        return Number(numberId);
    },

    showPopup: function({ content, imageUrl, width, imageSize } = {}) {
        try {
            const text = content;
            const globalToast = document.getElementById("global-toast");
            const toastContent = document.querySelector("#global-toast .toast-content");
            const toastImage = document.querySelector('#global-toast .toast-image img');
            const toastImageContainer = document.querySelector('#global-toast .toast-image');
      
            if (globalToast && toastContent && toastImage && toastImageContainer) {
                toastContent.innerHTML = text;
                if (width) {
                    globalToast.style.width = `${width}px`;
                }
                if (imageSize) {
                    toastImageContainer.style.maxWidth = `${imageSize}px`;
                    toastImageContainer.style.minWidth = `${imageSize}px`;
                    toastImageContainer.style.maxHeight = `${imageSize}px`;
                    toastImageContainer.style.minHeight = `${imageSize}px`;
                }

                if (imageUrl) {
                    toastImageContainer.style.display = 'block';
                    toastImage.src = imageUrl;
                    toastImage.onload = function () {
                        globalToast.style.display = 'flex';
                        setTimeout(() => {
                            toastImageContainer.style.display = 'none';
                            globalToast.style.display = 'none';
                        }, 5000);
                    }
                } else {
                    globalToast.style.display = 'flex';
                    setTimeout(() => {
                        toastImageContainer.style.display = 'none';
                        globalToast.style.display = 'none';
                    }, 5000);
                }
            }
        }  catch (err) {
            console.error(err);
        }
    },
    autoSelectCountry: function(){
        const isSelectedCountry = localStorage.getItem("isSelectedCountry");
        if (!isSelectedCountry || isSelectedCountry === "false") {
            fetch(PROXY_BASE_URL + "/customer-location",{
                method: 'get',
            }).then(async (response)=>{
                localStorage.setItem("isSelectedCountry", true);
                if(response.ok){
                  const data = await response.json();
                  let country = "US";
                  if (data && data.country && ["AU", "CA", "GB"].includes(data.country)) {
                    country = data.country;
                  }
                  localStorage.setItem("hasVisited", "true");
                  if(country == Shopify.country) return;
                  let url = new URL(window.location.href+'services/currency/update');
                  let params = new URLSearchParams(url.search);
                  params.set('country', country);
                  params.set('return_to', '/')
                  url.search = params.toString();
                  window.location.href = url.toString();
                }
              }).catch((error)=>{
                throw new Error(error.message);
              });
        }
    },
    getShortMonth: function(date) {
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
        let currentMonthIndex = date.getMonth();
        return monthNames[currentMonthIndex];
    },
    addBusinessDays: function(date, daysToAdd) {
        let currentDate = new Date(date);
        let addedDays = 0;
        
        while (addedDays < daysToAdd) {
            currentDate.setDate(currentDate.getDate() + 1);
            let dayOfWeek = currentDate.getDay();
            
            // Skip Saturday (6) and Sunday (0)
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            addedDays++;
            }
        }
        
        return currentDate;
    },
    /**
     * US product page: estimated arrival window (3–5 business days from reference date).
     * Uses window.releaseDate when set (e.g. pre-order), else today.
     * @returns {{ arrivingMsg: string, latestShippingDate: string, estimateDateRange: string }}
     */
    getUsDeliveryArrivalEstimate: function() {
        let currentDate = new Date();
        if (typeof window !== "undefined" && window.releaseDate) {
            currentDate = new Date(window.releaseDate);
        }
        const earliest = this.addBusinessDays(currentDate, 3);
        const latest = this.addBusinessDays(currentDate, 5);
        const monthEarly = this.getShortMonth(earliest);
        const monthLate = this.getShortMonth(latest);
        const sameMonth = monthEarly === monthLate;
        const enDash = "\u2013";
        const estimateDateRange = sameMonth
            ? monthEarly + " " + earliest.getDate() + enDash + latest.getDate()
            : monthEarly +
              " " +
              earliest.getDate() +
              enDash +
              monthLate +
              " " +
              latest.getDate();
        const arrivingMsg =
            "arriving " +
            monthEarly +
            " " +
            earliest.getDate() +
            " - " +
            (sameMonth
                ? String(latest.getDate())
                : monthLate + " " + latest.getDate());
        const latestShippingDate =
            monthEarly +
            " " +
            (sameMonth
                ? String(latest.getDate())
                : monthLate + " " + latest.getDate());
        return {
            arrivingMsg: arrivingMsg,
            latestShippingDate: latestShippingDate,
            estimateDateRange: estimateDateRange,
        };
    },
    formatJaxstaDuration: function(duration) {
        if (!duration) return ''
        const [hours, minutes, seconds] = duration.split(":");

        // Create a Date object (using a reference date)
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        // Check if hours are greater than 0
        const showHours = date.getHours() > 0;

        // Format the time dynamically
        const formattedTime = showHours
        ? `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
        : `${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

        return formattedTime

    },
    getCustomerAccessTokenByCredentials: async function() {
        try {
            if (
                localStorage.getItem("e_vinyl_customer_access_token") && sessionStorage.getItem("p_vinyl_customer_access_token")
            ) {
                const origin = PROXY_BASE_URL;
                const path = "/customer/customerAccessToken";
                const getATurl = `${origin}${path}`;
                const e = localStorage.getItem("e_vinyl_customer_access_token");
                const p = sessionStorage.getItem("p_vinyl_customer_access_token");
                const response = await fetch(getATurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ email: e, password: p })
                });
                const data = await response.json();
                utils.saveCustomerAccessToken(
                    data.customerAccessTokenCreate.customerAccessToken.accessToken,
                    data.customerAccessTokenCreate.customerAccessToken.expiresAt
                );
                localStorage.removeItem("e_vinyl_customer_access_token");
                sessionStorage.removeItem("p_vinyl_customer_access_token");
            }
        } catch (error) {
            console.log('error get customer access token by credentials', error);
        }
    },
    getABTestVariant: async () => {
        const VALID_AB_VARIANT_NAMES = ['control_july2026', 'variant_july2026'];
        function removeABTestVariant() {
            localStorage.removeItem('abTestId');
            localStorage.removeItem('abTestVariant');
            localStorage.removeItem('abTestCustomerId');
            utils.mixpanelRetryWrapper.unregister("product_page_test");
        }
            
        try {
            const abTestId = localStorage.getItem('abTestId');
            // const abTestStatus = localStorage.getItem('abTestStatus');
            const abTestUrl = `${window.location.origin}/apps/${APP_PROXY_NAME}/app/abtest`;
            const abTestRes = await fetch(abTestUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!abTestRes.ok) {
                throw new Error('Network response was not ok');
            }
            const abTestData = await abTestRes.json();
            if (!abTestData || !abTestData.id) {
                console.log("ab test id not exist");
                removeABTestVariant();
                return;
            }
            // check if abTestId is different from localStorage
            if (String(abTestId) !== String(abTestData.id)){
                removeABTestVariant();
                localStorage.setItem('abTestId', abTestData.id);
            }
            const customerId = shopifyCustomer?.customerId;
            //get deviceId from cookie, if not exist, create new deviceId and set to cookie
            let abTestDeviceId = localStorage.getItem('abTestDeviceId');
            const abTestVariant = localStorage.getItem('abTestVariant');
            // const abTestCustomerId = localStorage.getItem('abTestCustomerId');

            let variantObj = null;
            try { 
                variantObj = abTestVariant ? JSON.parse(abTestVariant) : null; 
            } catch(e) {
                console.log("Error when parse abTestVariant:", e);
            }
            if (variantObj?.name && VALID_AB_VARIANT_NAMES.includes(variantObj.name)) {
                utils.mixpanelRetryWrapper.register({"product_page_test": variantObj.name});
                return;
            }

            // Fetching new AB test variant
            removeABTestVariant();
            abTestDeviceId = null;

            // if abTestDeviceId not exist, create new deviceId and set to cookie
            if(!abTestDeviceId) {
                // Using Web Crypto API for generating unique device ID for A/B testing
                // This is a standard browser API (not malicious code)
                abTestDeviceId = crypto.randomUUID();
                localStorage.setItem('abTestDeviceId', abTestDeviceId);
            }
            // fetch
            const url = `${window.location.origin}/apps/${APP_PROXY_NAME}/app/abtest-variant?deviceId=${abTestDeviceId}&${customerId?`customerId=${customerId}`:''}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            let data = await response.json();
            const variantName = data?.variant?.name;
            console.log("Variant name - getABTestVariant:", variantName, VALID_AB_VARIANT_NAMES);
            if (variantName && VALID_AB_VARIANT_NAMES.includes(variantName)) {
                localStorage.setItem('abTestVariant', JSON.stringify(data.variant));
                localStorage.setItem('abTestCustomerId', customerId);
                utils.mixpanelRetryWrapper.register({"product_page_test": variantName});
            }
        } catch (error) {
            console.log("Error - getABTestVariant:", error);
        }
    },
    scrollToView: function (elementId) {
        const element = document.getElementById(elementId);
        element.scrollIntoView({ behavior: 'smooth' });
    },
    // VNYL-1472: the catch-all browser timezone capture for logged-in customers. Signups
    // made off the storefront (Shopify's hosted account pages, checkout) reach Airship
    // only through the customers/create webhook, which has no browser context and can
    // only derive a zone from the address. This runs on every page for a logged-in
    // customer and hands Airship the real one; the channel write is an upsert, so it
    // upgrades a derived zone to browser_native the first time that customer visits.
    // It also replaces the capture that used to live inline in theme.liquid, which
    // called window.airship before the async airship.js had loaded and then never
    // retried, because it stored the timezone before the call rather than after it.
    updateAirshipTimezone: function () {
        let airshipData = localStorage.getItem('airship');
        airshipData = airshipData && airshipData !== '' ? JSON.parse(airshipData) : null;

        const stored = airshipData?.timezone || {};
        const expiresAt = stored?.expiresAt || null;
        const email = shopifyCustomer?.email || null;

        if (!email) return;

        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // A timezone write is one-way on an Airship channel — a wrong value can be
            // overwritten but never cleared — so send nothing rather than a guess.
            if (!timezone) return;

            const expired = !expiresAt || new Date(expiresAt) < new Date();
            // Re-send as soon as the customer's zone changes (travel, a corrected clock),
            // not only when the 30-day window lapses.
            const changed = stored?.timezone !== timezone;
            if (!expired && !changed) return;

            const currency = Shopify?.currency?.active || 'USD'; // Default to USD if currency is not set
            const country = Shopify?.country || null;
            const url = `${window.location.origin}/apps/${APP_PROXY_NAME}/airship/timezone`;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ timezone, email, currency, country })
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Airship response was not ok');
                }
                // Only remember the timezone once Airship has it — otherwise a failed
                // write would be treated as done and never retried.
                localStorage.setItem('airship', JSON.stringify({
                    ...airshipData,
                    timezone: {
                        timezone,
                        expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() // Set new expiration date to 30 days from now
                    }
                }));
            }).catch(error => {
                console.error('Error updating Airship timezone:', error);
            });
        } catch (error) {
            console.error('Error getting timezone:', error);
        }
    },
    isMobileOrSmallScreen: function () {
        const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isSmallScreen = window.innerWidth < 600;
        return isMobileDevice || isSmallScreen;
    },
    onClickCart: function () {
        if (this.isMobileOrSmallScreen()) {
           const params = new URLSearchParams(window.location.search);
            params.set('cart', 'open');
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState(null, '', newUrl);
        }
    },
    // Preserve the page scroll position when the cart drawer closes. On hide, Bootstrap
    // returns focus to #cart-toggle-button; on mobile the header hides on scroll, so
    // focusing that (now off-screen) button makes the browser scroll it into view —
    // jumping the page to the top. We capture scrollY as the modal starts hiding and
    // restore it once hidden. Delegated on document because the modal is (re)rendered by
    // React, and gated to #myCartModal so other modals are unaffected.
    preserveCartScrollOnClose: function () {
        let cartScrollY = 0;
        document.addEventListener('hide.bs.modal', function (event) {
            if (event.target && event.target.id === 'myCartModal') {
                cartScrollY = window.scrollY;
            }
        });
        document.addEventListener('hidden.bs.modal', function (event) {
            if (event.target && event.target.id === 'myCartModal') {
                // Next frame, so it runs after Bootstrap's focus handling on close.
                requestAnimationFrame(function () {
                    window.scrollTo(0, cartScrollY);
                });
            }
        });
    },
    hideCart: function() {
        const cartModal = document.getElementById("myCartModal");
        if (cartModal) {
            const modal = bootstrap.Modal.getInstance(cartModal);
            if (modal) {
                modal.hide();
                // const params = new URLSearchParams(window.location.search);
                // params.delete('cart'); 
                // const newUrl = `${window.location.pathname}?${params.toString()}`;
                // window.history.replaceState({}, '', newUrl);
            }
        }
    },
    listenMobileCartClick: function () {
        const $cartToggleBtn = jQuery36('#cart-toggle-button');

        if ($cartToggleBtn.length && this.isMobileOrSmallScreen()) {
            $cartToggleBtn.on('click', function () {
                const $header = jQuery36('.header-group');
                const $search = jQuery36('#headerFormMobileSearch');

                if ($header.length && $search.length) {
                    $header.css('top', '0px');
                    $search.css('top', '100%');
                }
            });
        }
    },
    share: function() {
        if (navigator.share && window.currentProduct) {
            navigator.share({
                title: window.currentProduct?.title,
                text: window.currentProduct?.content,
                url: 'https://vinyl.com/products/' + window.currentProduct?.handle
            })
            .then(() => console.log('Shared successfully'))
            .catch((error) => console.error('Error sharing:', error));
        } else {
            console.log('Web Share API not supported on this browser.');
        }
    },
    getCreatorHandle: function(name) {
        return name
            .trim()
            .toLowerCase()
            .normalize("NFD")                // break accented characters (e.g. é → e + ́)
            .replace(/[\u0300-\u036f]/g, "") // remove diacritics
            .replace(/[^a-z0-9]+/g, "-")     // replace everything not a-z or 0-9 with "-"
            .replace(/^-+|-+$/g, "");        // remove leading/trailing hyphens
    },
    getCurrency: function() {
        const currency = window.Shopify.currency
        const country = window.Shopify.country

        if (currency?.symbol && currency?.symbol !== '') {
            return currency?.symbol
        }

        return country?.toLowerCase() === 'gb' ? '£' : '$'
    },
    _vinylSessionViewedProductHandlesKey: 'vinyl_session_viewed_product_handles',
    _getCurrentProductHandle: function() {
        const handleFromWindow = window.currentProduct && window.currentProduct.handle ? window.currentProduct.handle : null;
        if (handleFromWindow) return handleFromWindow;

        const match = window.location.pathname.match(/^\/products\/([^\/\?]+)/);
        return match && match[1] ? decodeURIComponent(match[1]) : null;
    },
    _vinylSiteSessionStartKey: 'vinyl_site_session_start_ts',
    ensureSiteSessionStart: function() {
        const existing = parseInt(sessionStorage.getItem(this._vinylSiteSessionStartKey) || '0', 10);
        if (existing && existing > 0) return existing;
        const start = Date.now();
        try {
            sessionStorage.setItem(this._vinylSiteSessionStartKey, String(start));
        } catch (e) {
            // ignore storage failures
        }
        return start;
    },
    getTimeOnSiteMs: function() {
        const start = this.ensureSiteSessionStart();
        return Math.max(0, Date.now() - start);
    },
    hasBeenOnSiteFor: function(seconds) {
        const s = typeof seconds === 'number' && isFinite(seconds) ? seconds : 60;
        return this.getTimeOnSiteMs() >= (s * 1000);
    },
    getSessionViewedProductHandles: function() {
        try {
            const raw = sessionStorage.getItem(this._vinylSessionViewedProductHandlesKey);
            const parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    },
    trackSessionProductPageView: function() {
        const isProductPage = window.location.pathname.startsWith('/products/');
        const existing = this.getSessionViewedProductHandles();
        if (!isProductPage) return existing.length;

        const handle = this._getCurrentProductHandle();
        const key = handle || window.location.pathname;
        if (existing.indexOf(key) !== -1) return existing.length;

        const next = existing.concat([key]).slice(-50);
        try {
            sessionStorage.setItem(this._vinylSessionViewedProductHandlesKey, JSON.stringify(next));
        } catch (e) {
            // ignore storage failures
        }
        return next.length;
    },
    hasViewedTwoProductPages: function() {
        return this.getSessionViewedProductHandles().length >= 2;
    },
    // VNYL-1434: track how deep into the site the current history entry sits, so
    // the mobile Back trigger can tell "Back stays on vinyl.com" from "Back
    // leaves vinyl.com". This runs on EVERY page load, independent of whether
    // the popup is eligible here, because pages that never show the popup
    // (/cart, /pages/*, /blogs/*) still advance the visitor's in-site history.
    //
    // The depth is carried on history.state so it survives Back/Forward and
    // reloads; deriving it from document.referrer at fire time would mislead us,
    // since once the visitor backs into an earlier page the referrer points at
    // an in-site page.
    trackInSiteDepth: function () {
        function readTaggedDepth() {
            return history.state && typeof history.state.vinylDepth === 'number'
                ? history.state.vinylDepth
                : null;
        }

        function publish(depth) {
            window.__vinylInSiteDepth = depth;
            try {
                sessionStorage.setItem(VINYL_INSITE_DEPTH_KEY, String(depth));
            } catch (e) {
                // ignore storage failures
            }
        }

        function computeDepth() {
            // A restored entry (Back/Forward/reload) already knows its depth.
            const tagged = readTaggedDepth();
            if (tagged !== null) return tagged;
            // Fresh navigation: a same-origin referrer means we went one level
            // deeper into the site; anything else means we just (re)entered it.
            let sameOrigin = false;
            try {
                sameOrigin = !!document.referrer &&
                    new URL(document.referrer).origin === window.location.origin;
            } catch (e) {
                sameOrigin = false;
            }
            const prev = parseInt(sessionStorage.getItem(VINYL_INSITE_DEPTH_KEY) || '0', 10);
            return sameOrigin && prev > 0 ? prev + 1 : 1;
        }

        const depth = computeDepth();
        try {
            history.replaceState(
                Object.assign({}, history.state, { vinylDepth: depth }),
                '',
                window.location.href
            );
        } catch (e) {
            // ignore history failures
        }
        publish(depth);

        // A bfcache restore does not re-run this script, so re-publish the depth
        // carried on the restored entry — otherwise the stored value stays at the
        // deeper page we came back from and inflates every later navigation.
        window.addEventListener('pageshow', function (event) {
            if (!event.persisted) return;
            const tagged = readTaggedDepth();
            if (tagged !== null) publish(tagged);
        });
    },
    welcomeDiscountHandler: async function() {
        // VNYL-1435: suppress the popup for bot traffic (headless/Linux that the
        // analytics is_bot verdict misses). Return before any trigger is armed so
        // no "Popup Displayed" event fires. Fails open (shows popup) on error.
        if (typeof utils !== 'undefined' && utils.isLikelyBotForPopup && utils.isLikelyBotForPopup()) {
            return;
        }

        const SESSION_KEYS = {
            sessionStart: 'vinyl_welcome_discount_session_start',
            autoShown: 'vinyl_welcome_discount_auto_shown',
            productViews: 'vinyl_welcome_discount_product_views',
            addedToCart: 'vinyl_welcome_discount_added_to_cart',
            badgeEnabled: 'vinyl_welcome_discount_badge_enabled',
            closeCount: 'vinyl_welcome_discount_close_count',
            exitIntentSeen: 'vinyl_welcome_discount_exit_intent_seen'
        };

        const LOCAL_KEYS = {
            dismissedUntil: 'vinyl_welcome_discount_dismissed_until',
            emailSubmitted: 'vinyl_welcome_discount_email_submitted',
            openedByScript: 'vinyl_welcome_discount_opened_by_script',
            closeModal: 'vinyl_welcome_close_modal',
            triggeredBy: 'vinyl_welcome_discount_triggered_by'
        };

        const WIDGET_SELECTOR = '#collectinng-email-popup .widget .title';

        // The popup DOM belongs to the app embed, which can mount after this
        // handler runs — so look it up at fire time, never once at start-up.
        function findWidget() {
            return document.querySelector(WIDGET_SELECTOR);
        }

        // Returns whether the popup was actually opened, so callers only burn
        // their one-shot trigger flag when the popup really showed.
        function openModal(triggeredBy) {
            const widget = findWidget();
            if (!widget) {
                console.log("Widget is not existed");
                return false;
            }
            // Signal to the popup app-extension that this open was script-driven,
            // so it does not also fire a "Popup Reopened" event for the same show.
            window.__vinylWelcomePopupScriptOpen = true;
            widget.click();
            localStorage.setItem(LOCAL_KEYS.openedByScript, 'true');
            // Persist what triggered the popup so a resulting signup can be
            // attributed to the trigger on the server-side "User Subscribed" event.
            try {
                localStorage.setItem(LOCAL_KEYS.triggeredBy, triggeredBy);
            } catch (e) {
                // ignore storage failures
            }
            try {
                if (typeof utils !== 'undefined' && utils.mixpanelRetryWrapper) {
                    utils.mixpanelRetryWrapper.track('Popup Displayed', {
                        triggered_by: triggeredBy,
                        page_type: self.getPageNameFromUrl(),
                    });
                }
            } catch (e) {
                // ignore tracking failures
            }
            return true;
        }

        // Same as openModal(), but waits briefly for the app embed to mount its
        // popup. Used by the Back trigger, which can fire while the embed is
        // still loading. Resolves to whether the popup opened.
        function openModalWhenReady(triggeredBy) {
            const MAX_ATTEMPTS = 10;
            const RETRY_MS = 150;
            return new Promise(function (resolve) {
                let attempts = 0;
                (function attempt() {
                    if (openModal(triggeredBy)) return resolve(true);
                    attempts += 1;
                    if (attempts >= MAX_ATTEMPTS) return resolve(false);
                    setTimeout(attempt, RETRY_MS);
                })();
            });
        }

        function isOpenModalByScript() {
            return localStorage.getItem(LOCAL_KEYS.openedByScript) === 'true';
        }

        function isUserCloseModal() {
            return localStorage.getItem(LOCAL_KEYS.closeModal) === 'true';
        }

        const PRODUCT_VIEWS_THRESHOLD = 2;

        const isProductPage = window.location.pathname.startsWith('/products/');
        const self = this;

        // Pages allowed to run the exit-intent trigger (VNYL-1421). The other two
        // triggers (2 product views / 120s on site) stay product-page only.
        const EXIT_INTENT_PAGES = ['home', 'collection', 'collections-home', 'search', 'shop', 'product'];
        const isExitIntentPage = EXIT_INTENT_PAGES.indexOf(self.getPageNameFromUrl()) !== -1;

        // Which exit-intent trigger this device gets: the mouse-leaves-viewport
        // one only where there is a real pointer. Everything else — phones and
        // tablets, where mouseleave never fires — gets the Back-button trigger
        // (VNYL-1434), including tablets wider than the 768px breakpoint.
        const hasFinePointer = !!(window.matchMedia &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches);
        const useDesktopExitIntent = hasFinePointer && window.innerWidth > 768;

        function now() { return Date.now(); }

        function cond_emailSubmitted() {
            return localStorage.getItem(LOCAL_KEYS.emailSubmitted) === 'true';
        }

        function cond_dismissed() {
            const untilStr = localStorage.getItem(LOCAL_KEYS.dismissedUntil);
            const until = untilStr ? parseInt(untilStr, 10) : 0;
            return Boolean(until && until > now());
        }

        function rule_ensureSessionStart() {
            const existing = parseInt(sessionStorage.getItem(SESSION_KEYS.sessionStart) || '0', 10);
            if (existing && existing > 0) return existing;
            const start = now();
            sessionStorage.setItem(SESSION_KEYS.sessionStart, String(start));
            return start;
        }

        function rule_recordProductView() {
            const count = self.trackSessionProductPageView();
            try {
                sessionStorage.setItem(SESSION_KEYS.productViews, String(count));
            } catch (e) {
                // ignore storage failures
            }
            return count;
        }

        function hasViewedTwoProductPages() {
            return self.getSessionViewedProductHandles().length >= PRODUCT_VIEWS_THRESHOLD;
        }

        function cond_exitIntentSeen() {
            return sessionStorage.getItem(SESSION_KEYS.exitIntentSeen) === 'true';
        }

        function rule_markExitIntentSeen() {
            try {
                sessionStorage.setItem(SESSION_KEYS.exitIntentSeen, 'true');
            } catch (e) {
                // ignore storage failures
            }
        }

        rule_ensureSessionStart();
        rule_recordProductView();

        if (cond_emailSubmitted() || cond_dismissed() || isUserCloseModal()) {
            return;
        }

        if (!isProductPage && !isExitIntentPage) {
            return;
        }

        // CONDITION: Exit intent — mobile (VNYL-1434)
        // The Back button is the mobile equivalent of exit intent. We show the
        // popup only when pressing Back would leave vinyl.com — i.e. the visitor
        // is still on the page they entered the site on (in-site depth 1, see
        // app.trackInSiteDepth). On deeper pages we never touch history at all,
        // so Back walks back through the site untouched.
        //
        // Armed on the visitor's first interaction (see armMobileBackTrigger),
        // well before the cart lookup below, so a fast Back press on a slow
        // connection is not missed; everything that needs a fresh answer is
        // re-checked at fire time instead.
        let armedUrl = window.location.href;
        // Identifies the sentinel THIS page load pushed. Entries tagged by an
        // earlier load of the same URL carry a different token, so we can tell
        // "back onto our own sentinel" from "back onto a stale one".
        const sentinelToken = 'vnyl-' + Date.now() + '-' + Math.random().toString(36).slice(2);

        async function handleBackExit() {
            // We are sitting ON our own sentinel, which means we came back DOWN
            // onto it from an entry pushed above us by something else (e.g. the
            // mobile cart drawer's ?cart=open). Not an exit — keep the sentinel
            // and the single interception we allow ourselves.
            if (history.state && history.state.vinylExitSentinel === sentinelToken) return;
            if (window.location.href !== armedUrl) return;

            // Popped off the sentinel: this is the exit moment. Release history
            // from here on so the next Back press leaves the site as expected —
            // never re-push, or the visitor is trapped on the page.
            window.removeEventListener('popstate', handleBackExit);

            // The sentinel has already swallowed this Back press. Whenever we
            // decide NOT to show the popup we have to hand that press back, or
            // the visitor taps Back and simply nothing happens. The listener is
            // gone by now, so this second pop leaves the site as they intended.
            function releaseBack() {
                history.back();
            }

            if (isOpenModalByScript() || cond_exitIntentSeen() || isUserCloseModal()) {
                return releaseBack();
            }
            if (await cartHasItems()) return releaseBack();

            console.log('Open modal by exit intent - mobile back button');
            // Mark the trigger as used only once the popup really opened, so a
            // still-mounting app embed does not silently burn it for the session.
            if (await openModalWhenReady('exit_intent')) {
                rule_markExitIntentSeen();
            } else {
                releaseBack();
            }
        }

        function armMobileBackTrigger() {
            if (cond_exitIntentSeen()) return;
            // Deeper than the entry page: Back stays on vinyl.com, leave it alone.
            if (window.__vinylInSiteDepth !== 1) return;
            // Re-read the URL: another script may have rewritten it since load
            // (collection filters push their own entries), and the sentinel has
            // to sit on the URL we will be popped back onto.
            armedUrl = window.location.href;
            // Always push our OWN sentinel, even when the current entry already
            // carries one from an earlier load of this URL: a stale sentinel
            // belongs to a discarded document, so popping onto it is a
            // cross-document navigation that never fires popstate.
            try {
                history.pushState({ vinylExitSentinel: sentinelToken, vinylDepth: 1 }, '', armedUrl);
            } catch (e) {
                return;
            }
            window.addEventListener('popstate', handleBackExit);
        }

        // The sentinel must be pushed WHILE the page has user activation.
        // Chrome's history-manipulation intervention marks any entry pushed
        // before the visitor has interacted as "skippable" and the Back button
        // walks straight past it — so arming at page load (as this did) meant
        // Back left vinyl.com and popstate never fired on Android. Verified on
        // a Pixel emulator: identical sentinel, intercepted only when pushed
        // after a tap. Note `scroll` does NOT grant activation, so it cannot be
        // used as the arming signal.
        function armMobileBackTriggerOnFirstInteraction() {
            const ACTIVATION_EVENTS = ['pointerdown', 'touchend', 'click', 'keydown'];
            let armed = false;
            function onFirstInteraction() {
                if (armed) return;
                armed = true;
                ACTIVATION_EVENTS.forEach(function (evt) {
                    window.removeEventListener(evt, onFirstInteraction, true);
                });
                armMobileBackTrigger();
            }
            ACTIVATION_EVENTS.forEach(function (evt) {
                // Capture phase + passive: we only observe, and must not be
                // skipped by a handler that stops propagation.
                window.addEventListener(evt, onFirstInteraction, { capture: true, passive: true });
            });
        }

        if (isExitIntentPage && !useDesktopExitIntent) {
            armMobileBackTriggerOnFirstInteraction();
        }

        function cartHasItems() {
            return fetch(
                (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                    ? window.Shopify.routes.root + 'cart.js'
                    : '/cart.js',
                { method: 'GET', cache: 'no-store' }
            )
            .then(function(res){ return res && res.ok ? res.json() : null; })
            .then(function(cart){
                const itemCount = cart && cart.item_count != null ? cart.item_count : 0;
                return itemCount > 0;
            })
            .catch(function(){ return false; });
        }

        const hasCardItems = await cartHasItems();

        if (hasCardItems) {
            return;
        }

        if (isProductPage) {
            // CONDITION: 2 products page view
            if (hasViewedTwoProductPages() && !isOpenModalByScript()) {
                console.log('Open modal by view 2 product pages');
                openModal('product_views');
                return;
            }

            // CONDITION: 120s (VNYL-1433)
            clearInterval(welcomeIntervalId);
            welcomeIntervalId = setInterval(() => {
                const startTime = parseInt(sessionStorage.getItem(SESSION_KEYS.sessionStart) || '0', 10);
                if (Date.now() - startTime >= 120 * 1000 && !isOpenModalByScript()) {
                    clearInterval(welcomeIntervalId);
                    welcomeIntervalId = null;
                    console.log('Open modal by stay in 120s');
                    openModal('time_on_site');
                }
            }, 1000);
        }

        // CONDITION: Exit intent — desktop (the mobile Back trigger is armed
        // earlier, before the cart lookup above).
        if (!isExitIntentPage || cond_exitIntentSeen() || !useDesktopExitIntent) {
            return;
        }

        function handleMouseLeave(e) {
            console.log('handleMouseLeave', e.clientY, e.movementY)
            // Mouse going upward and near top of viewport
            if (e.clientY <= 0 && !isOpenModalByScript() && !cond_exitIntentSeen()) {
                console.log('Open modal by exit intent: handleMouseLeave');
                if (openModal('exit_intent')) {
                    rule_markExitIntentSeen();
                }
                document.removeEventListener("mouseleave", handleMouseLeave);
            }
        }

        setTimeout(() => {
            document.addEventListener("mouseleave", handleMouseLeave);
        }, 2000);
    }
};
// VNYL-1481: all.js is `defer` now, so the inline block in layout/theme.liquid
// that writes liquidVariables.adsSettings / .globalSettingVariables runs at parse
// time — i.e. BEFORE this file. Adopt whatever it already put there instead of
// replacing it with a fresh {}, or those settings are silently lost and every
// bundle reading them throws "Cannot read properties of undefined".
const liquidVariables = window.liquidVariables || {};
window.liquidVariables = liquidVariables;
window.app = app;
window.isSearchOpenDefaultUrl = isSearchOpenDefaultUrl;
app.handleOldArticleUrl();
app.checkContainerOffsetLeft();
app.checkContainerOffsetRight();
jQuery36(document).ready(function () {
    // new WOW().init();

    app.init();

    jQuery36(window).scroll(function () {
        // Code here
    });
    jQuery36(window).on("load", function () {
        // Code here
    });

    jQuery36(window).on("resize", function () {
        app.headerActions();
        app.checkContainerOffsetLeft();
        app.mobileFilter();
    });
});
